import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: any }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export type Query = {
  __typename?: 'Query';
  /** Get a list of sms messages */
  messages: Array<Message>;
  calls: CallsListResponse;
  /** Get a list of contacts */
  contacts: ContactListResponse;
  contact: Contact;
  /** Get a list of message threads */
  messageThreads: Array<MessageThread>;
  /** Gets a thread of SMS messages */
  messageThread: MessageThread;
  /** Get a list of number services */
  numbers: Array<Service>;
  /** Get a number service */
  number: Service;
  /** Get a list of billing accounts */
  billingAccounts: Array<BillingAccount>;
  /** Get a billing account */
  billingAccount: BillingAccount;
  /** Get a list of bills */
  billingBills: BillListResponse;
  /** Get a list of payments */
  billingPayments: PaymentListResponse;
  flows: Array<Flow>;
  flow: Flow;
  flowLogs: FlowLogListResponse;
  flowLog: FlowLog;
  /** Get a list of internet services */
  internetServices: InternetServiceListResponse;
  /** Get an internet service */
  internetService: InternetService;
  /** Get a list of phone lines */
  phoneLines: PhoneLineListResponse;
  /** Get a phone line service */
  phoneLine: PhoneLine;
  /** Get a list of call recordings */
  recordings: RecordingListResponse;
  /** Get a call recording */
  recording: Recording;
  /** Get a list of phone systems */
  phoneSystems: Array<PhoneSystem>;
  /** Get a phone system */
  phoneSystem: PhoneSystem;
  /** Get a list of phone system extensions */
  phoneSystemExtensions: Array<PhoneSystemExtension>;
  /** Get a phone system extension */
  phoneSystemExtension: PhoneSystemExtension;
  /** Get a list of phone system hunt group */
  phoneSystemHuntGroups: Array<PhoneSystemHuntGroup>;
  /** Get a phone system hunt group */
  phoneSystemHuntGroup: PhoneSystemHuntGroup;
  /** Get a list of phone system numbers */
  phoneSystemNumbers: Array<PhoneSystemNumber>;
  /** Get a list of available DID numbers */
  searchPhoneSystemDIDNumbers: Array<PhoneSystemNumberDid>;
  /** Get a list of usage plans */
  usagePlans: Array<UsagePlan>;
  /** Get a usage plan */
  usagePlan: UsagePlan;
  /** Get a list of available mobile services */
  searchMobileServiceNumbers: Array<MobileServiceNumber>;
};


export type QueryMessagesArgs = {
  otherNumber?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
};


export type QueryCallsArgs = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
  filterDate?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
};


export type QueryContactsArgs = {
  phoneNumber?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
};


export type QueryContactArgs = {
  id: Scalars['String'];
};


export type QueryMessageThreadsArgs = {
  serviceId?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
};


export type QueryMessageThreadArgs = {
  otherNumber: Scalars['String'];
  serviceId: Scalars['String'];
};


export type QueryNumbersArgs = {
  capabilityFax?: Maybe<Scalars['Boolean']>;
  capabilityVoice?: Maybe<Scalars['Boolean']>;
  capabilitySms?: Maybe<Scalars['Boolean']>;
};


export type QueryNumberArgs = {
  id: Scalars['String'];
};


export type QueryBillingAccountArgs = {
  ban: Scalars['String'];
};


export type QueryBillingBillsArgs = {
  page?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
  ban?: Maybe<Scalars['String']>;
};


export type QueryBillingPaymentsArgs = {
  page?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
  ban?: Maybe<Scalars['String']>;
};


export type QueryFlowArgs = {
  id: Scalars['String'];
};


export type QueryFlowLogsArgs = {
  flowId: Scalars['String'];
  page?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
};


export type QueryFlowLogArgs = {
  id: Scalars['String'];
};


export type QueryInternetServicesArgs = {
  page?: Maybe<Scalars['Float']>;
  type?: Maybe<Array<Scalars['String']>>;
  limit?: Maybe<Scalars['Float']>;
};


export type QueryInternetServiceArgs = {
  id: Scalars['String'];
};


export type QueryPhoneLinesArgs = {
  page?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
  search?: Maybe<Scalars['String']>;
  ban?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Scalars['String']>>;
};


export type QueryPhoneLineArgs = {
  id: Scalars['String'];
};


export type QueryRecordingsArgs = {
  from?: Maybe<Scalars['String']>;
  ban?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
};


export type QueryRecordingArgs = {
  recordingId: Scalars['String'];
};


export type QueryPhoneSystemsArgs = {
  page?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
  ban?: Maybe<Scalars['String']>;
};


export type QueryPhoneSystemArgs = {
  id: Scalars['String'];
};


export type QueryPhoneSystemExtensionsArgs = {
  phoneSystemId: Scalars['String'];
};


export type QueryPhoneSystemExtensionArgs = {
  id: Scalars['String'];
};


export type QueryPhoneSystemHuntGroupsArgs = {
  phoneSystemId: Scalars['String'];
};


export type QueryPhoneSystemHuntGroupArgs = {
  huntGroupId: Scalars['String'];
};


export type QueryPhoneSystemNumbersArgs = {
  phoneSystemId: Scalars['String'];
};


export type QuerySearchPhoneSystemDidNumbersArgs = {
  page?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
  query: Scalars['String'];
};


export type QueryUsagePlanArgs = {
  alias: Scalars['String'];
};


export type QuerySearchMobileServiceNumbersArgs = {
  page?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
  query: Scalars['String'];
};

export type Message = {
  __typename?: 'Message';
  id: Scalars['ID'];
  ban: Scalars['String'];
  serviceId: Scalars['String'];
  accountSid: Scalars['String'];
  body: Scalars['String'];
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  dateSent: Scalars['String'];
  direction: Scalars['String'];
  errorCode: Scalars['Int'];
  errorMessage: Scalars['String'];
  from: Scalars['String'];
  messagingServiceSid: Scalars['String'];
  numMedia: Scalars['Int'];
  numSegments: Scalars['Int'];
  price: Scalars['Float'];
  priceUnit: Scalars['String'];
  sid: Scalars['String'];
  status: Scalars['String'];
  to: Scalars['String'];
  billingAccount?: Maybe<BillingAccount>;
  service?: Maybe<Service>;
  number: Scalars['String'];
  otherNumber: Scalars['String'];
};

export type BillingAccount = {
  __typename?: 'BillingAccount';
  id: Scalars['ID'];
  ban: Scalars['String'];
  name: Scalars['String'];
  abn: Scalars['String'];
  customer: Scalars['String'];
  customerId: Scalars['String'];
  address: Scalars['String'];
  suburb: Scalars['String'];
  state: Scalars['String'];
  postalCode: Scalars['String'];
  paymentTerms: Scalars['String'];
  billAttachments: Array<Scalars['String']>;
  invoiceDelivery: Scalars['String'];
  creditCardLast4Digits: Scalars['String'];
  creditCardExpire: Scalars['String'];
  creditCardBrand: Scalars['String'];
  creditCardCountry: Scalars['String'];
  accountCategory: Scalars['String'];
  twilioAccount: Scalars['String'];
  acsPartition: Scalars['String'];
};

export type Service = {
  __typename?: 'Service';
  id: Scalars['ID'];
  ban: Scalars['String'];
  usagePlan: Scalars['String'];
  usagePlanId: Scalars['String'];
  number: Scalars['String'];
  customer: Scalars['String'];
  customerId: Scalars['String'];
  serviceType: Scalars['String'];
  productType: Scalars['String'];
  customerReference?: Maybe<Scalars['String']>;
  contractTerm: Scalars['Int'];
  billingStatus: Scalars['String'];
  isSmartNumber: Scalars['Boolean'];
  monthlyCharge: Scalars['Float'];
  relatedService: Scalars['String'];
  relatedServiceId: Scalars['String'];
  answerPoint: Scalars['String'];
  contractEnd?: Maybe<Scalars['String']>;
  billingStartDate: Scalars['String'];
  billingEndDate?: Maybe<Scalars['String']>;
  currentStatus: Scalars['String'];
  dateAdded: Scalars['String'];
  username: Scalars['String'];
  password: Scalars['String'];
  twilioNumberId: Scalars['String'];
  twilioCallFlowId: Scalars['String'];
  twilioSmsFlowId: Scalars['String'];
  twilioFaxFlowId: Scalars['String'];
  twilioCapabilities: ServiceTwilioCapabilities;
  customerIp?: Maybe<Scalars['String']>;
  subnetMask?: Maybe<Scalars['String']>;
  gatewayIp?: Maybe<Scalars['String']>;
  primaryDns?: Maybe<Scalars['String']>;
  secondaryDns?: Maybe<Scalars['String']>;
  cpeType?: Maybe<Scalars['String']>;
  ntuPort?: Maybe<Scalars['String']>;
  ntdSerial?: Maybe<Scalars['String']>;
  simNumber?: Maybe<Scalars['String']>;
  nbnDisconnectionDate?: Maybe<Scalars['String']>;
  nbnLocationId?: Maybe<Scalars['String']>;
  lastBatteryReplacementDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  liftGatewayCases?: Maybe<Scalars['String']>;
  portaAccount?: Maybe<Scalars['String']>;
  portaExtension?: Maybe<Scalars['String']>;
  portaHuntGroup?: Maybe<Scalars['String']>;
  phoneSystem?: Maybe<Scalars['String']>;
  phoneSystemId?: Maybe<Scalars['String']>;
  flowId?: Maybe<Scalars['String']>;
  billingAccount?: Maybe<BillingAccount>;
  twilioCallFlow?: Maybe<Flow>;
  twilioSmsFlow?: Maybe<Flow>;
  twilioFaxFlow?: Maybe<Flow>;
};

export type ServiceTwilioCapabilities = {
  __typename?: 'ServiceTwilioCapabilities';
  voice: Scalars['Boolean'];
  SMS: Scalars['Boolean'];
  MMS: Scalars['Boolean'];
  fax: Scalars['Boolean'];
};

export type Flow = {
  __typename?: 'Flow';
  ban?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  published?: Maybe<FlowGraph>;
  userId?: Maybe<Scalars['String']>;
  lastEdited?: Maybe<Scalars['String']>;
  lastPublished?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type: Scalars['String'];
  gridSize: Scalars['Float'];
  links: Array<Scalars['JSONObject']>;
  nodes: Array<Scalars['JSONObject']>;
  offsetX: Scalars['Float'];
  offsetY: Scalars['Float'];
  zoom: Scalars['Float'];
  billingAccount?: Maybe<BillingAccount>;
};

export type FlowGraph = {
  __typename?: 'FlowGraph';
  id: Scalars['ID'];
  type: Scalars['String'];
  gridSize: Scalars['Float'];
  links: Array<Scalars['JSONObject']>;
  nodes: Array<Scalars['JSONObject']>;
  offsetX: Scalars['Float'];
  offsetY: Scalars['Float'];
  zoom: Scalars['Float'];
};


export type CallsListResponse = {
  __typename?: 'CallsListResponse';
  totalResults: Scalars['Int'];
  totalPages: Scalars['Int'];
  page: Scalars['Int'];
  limit: Scalars['Int'];
  results: Array<Call>;
};

export type Call = {
  __typename?: 'Call';
  dateTime: Scalars['String'];
  number: Scalars['String'];
  answerPoint: Scalars['String'];
  answerPointType: Scalars['String'];
  incomingCaller: Scalars['String'];
  incomingCallType: Scalars['String'];
  callStatusCode: Scalars['String'];
  callStatus: Scalars['String'];
  duration: Scalars['Float'];
  state: Scalars['String'];
  location: Scalars['String'];
  month: Scalars['String'];
  dayOfWeek: Scalars['String'];
  dayOfMonth: Scalars['String'];
  dayType: Scalars['String'];
  hourOfCall: Scalars['String'];
  hourOfCall12: Scalars['String'];
  hourType: Scalars['String'];
  target: Scalars['String'];
  usageType: Scalars['String'];
  amountCharged: Scalars['Float'];
};

export type ContactListResponse = {
  __typename?: 'ContactListResponse';
  totalResults: Scalars['Int'];
  totalPages: Scalars['Int'];
  page: Scalars['Int'];
  limit: Scalars['Int'];
  results: Array<Contact>;
};

export type Contact = {
  __typename?: 'Contact';
  /** Pickle contact id */
  id: Scalars['ID'];
  /** Created date */
  created: Scalars['String'];
  /** Last edited date */
  lastEdited: Scalars['String'];
  /** Last active flow */
  lastActive: Scalars['String'];
  /** User id */
  userId?: Maybe<Scalars['String']>;
  /** First name */
  firstName?: Maybe<Scalars['String']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']>;
  /** Company name */
  company?: Maybe<Scalars['String']>;
  /** Contact email */
  email?: Maybe<Scalars['String']>;
  /** Phone numbers in order of priority */
  phoneNumbers?: Maybe<Array<Scalars['String']>>;
  /** Custom fields */
  customFields?: Maybe<Scalars['JSONObject']>;
  /** Tags */
  tags?: Maybe<Array<Scalars['String']>>;
  /** Flows the users has been subscribed to */
  flows?: Maybe<Array<ContactFlowsList>>;
  /** A list of flow logs for this contact */
  flowLogs?: Maybe<FlowLogListResponse>;
  /** A list of recent messages */
  messages?: Maybe<MessageListResponse>;
};


export type ContactFlowLogsArgs = {
  page?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
};


export type ContactMessagesArgs = {
  page?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
};

export type ContactFlowsList = {
  __typename?: 'ContactFlowsList';
  flowId: Scalars['String'];
  flowLogId: Scalars['String'];
  timestamp: Scalars['String'];
};

export type FlowLogListResponse = {
  __typename?: 'FlowLogListResponse';
  totalResults: Scalars['Int'];
  totalPages: Scalars['Int'];
  page: Scalars['Int'];
  limit: Scalars['Int'];
  results: Array<FlowLog>;
};

export type FlowLog = {
  __typename?: 'FlowLog';
  id: Scalars['ID'];
  created: Scalars['String'];
  contactId: Scalars['String'];
  flowId: Scalars['String'];
  events: Array<FlowLogEvent>;
  env: Scalars['JSONObject'];
  contact?: Maybe<Contact>;
  flow?: Maybe<Flow>;
};

export type FlowLogEvent = {
  __typename?: 'FlowLogEvent';
  nodeId: Scalars['ID'];
  timestamp: Scalars['String'];
  type: Scalars['String'];
  config: Scalars['JSONObject'];
  result: Scalars['JSONObject'];
  error: Scalars['JSONObject'];
};

export type MessageListResponse = {
  __typename?: 'MessageListResponse';
  totalResults: Scalars['Int'];
  totalPages: Scalars['Int'];
  page: Scalars['Int'];
  limit: Scalars['Int'];
  results: Array<Message>;
};

export type MessageThread = {
  __typename?: 'MessageThread';
  id: Scalars['ID'];
  serviceId: Scalars['String'];
  number: Scalars['String'];
  otherNumber: Scalars['String'];
  lastMessage: Message;
  messages: Array<Message>;
  contact?: Maybe<Contact>;
  service?: Maybe<Service>;
};

export type BillListResponse = {
  __typename?: 'BillListResponse';
  totalResults: Scalars['Int'];
  totalPages: Scalars['Int'];
  page: Scalars['Int'];
  limit: Scalars['Int'];
  results: Array<Bill>;
};

export type Bill = {
  __typename?: 'Bill';
  id: Scalars['ID'];
  ban: Scalars['String'];
  billNumber: Scalars['String'];
  status: Scalars['String'];
  date: Scalars['String'];
  dueDate: Scalars['String'];
  amountDue: Scalars['Float'];
  amountPaid: Scalars['Float'];
  subTotal: Scalars['Float'];
  totalTax: Scalars['Float'];
  total: Scalars['Float'];
  reference: Scalars['String'];
  lineItems: Array<BillLineItem>;
  documents: Array<BillDocument>;
};

export type BillLineItem = {
  __typename?: 'BillLineItem';
  description: Scalars['String'];
  quantity: Scalars['Float'];
  unitAmount: Scalars['Float'];
  lineAmount: Scalars['Float'];
  discountRate: Scalars['Float'];
};

export type BillDocument = {
  __typename?: 'BillDocument';
  id: Scalars['ID'];
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
  contentLength: Scalars['Int'];
};

export type PaymentListResponse = {
  __typename?: 'PaymentListResponse';
  totalResults: Scalars['Int'];
  totalPages: Scalars['Int'];
  page: Scalars['Int'];
  limit: Scalars['Int'];
  results: Array<Payment>;
};

export type Payment = {
  __typename?: 'Payment';
  id: Scalars['ID'];
  ban: Scalars['String'];
  date: Scalars['String'];
  amount: Scalars['Float'];
  reference: Scalars['String'];
  billId: Scalars['String'];
  billNumber: Scalars['String'];
};

export type InternetServiceListResponse = {
  __typename?: 'InternetServiceListResponse';
  totalResults: Scalars['Int'];
  totalPages: Scalars['Int'];
  page: Scalars['Int'];
  limit: Scalars['Int'];
  results: Array<InternetService>;
};

export type InternetService = {
  __typename?: 'InternetService';
  id: Scalars['ID'];
  ban: Scalars['String'];
  usagePlan: Scalars['String'];
  usagePlanId: Scalars['String'];
  number: Scalars['String'];
  customer: Scalars['String'];
  customerId: Scalars['String'];
  serviceType: Scalars['String'];
  productType: Scalars['String'];
  customerReference?: Maybe<Scalars['String']>;
  contractTerm: Scalars['Int'];
  billingStatus: Scalars['String'];
  isSmartNumber: Scalars['Boolean'];
  monthlyCharge: Scalars['Float'];
  relatedService: Scalars['String'];
  relatedServiceId: Scalars['String'];
  answerPoint: Scalars['String'];
  contractEnd?: Maybe<Scalars['String']>;
  billingStartDate?: Maybe<Scalars['String']>;
  billingEndDate?: Maybe<Scalars['String']>;
  currentStatus: Scalars['String'];
  dateAdded: Scalars['String'];
  username: Scalars['String'];
  password: Scalars['String'];
  twilioNumberId: Scalars['String'];
  twilioCallFlowId: Scalars['String'];
  twilioSmsFlowId: Scalars['String'];
  twilioFaxFlowId: Scalars['String'];
  twilioCapabilities: ServiceTwilioCapabilities;
  customerIp?: Maybe<Scalars['String']>;
  subnetMask?: Maybe<Scalars['String']>;
  gatewayIp?: Maybe<Scalars['String']>;
  primaryDns?: Maybe<Scalars['String']>;
  secondaryDns?: Maybe<Scalars['String']>;
  cpeType?: Maybe<Scalars['String']>;
  ntuPort?: Maybe<Scalars['String']>;
  ntdSerial?: Maybe<Scalars['String']>;
  simNumber?: Maybe<Scalars['String']>;
  nbnDisconnectionDate?: Maybe<Scalars['String']>;
  nbnLocationId?: Maybe<Scalars['String']>;
  lastBatteryReplacementDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  liftGatewayCases?: Maybe<Scalars['String']>;
  portaAccount?: Maybe<Scalars['String']>;
  portaExtension?: Maybe<Scalars['String']>;
  portaHuntGroup?: Maybe<Scalars['String']>;
  phoneSystem?: Maybe<Scalars['String']>;
  phoneSystemId?: Maybe<Scalars['String']>;
  flowId?: Maybe<Scalars['String']>;
  billingAccount?: Maybe<BillingAccount>;
  twilioCallFlow?: Maybe<Flow>;
  twilioSmsFlow?: Maybe<Flow>;
  twilioFaxFlow?: Maybe<Flow>;
};

export type PhoneLineListResponse = {
  __typename?: 'PhoneLineListResponse';
  totalResults: Scalars['Int'];
  totalPages: Scalars['Int'];
  page: Scalars['Int'];
  limit: Scalars['Int'];
  results: Array<PhoneLine>;
};

export type PhoneLine = {
  __typename?: 'PhoneLine';
  id: Scalars['ID'];
  ban: Scalars['String'];
  usagePlan?: Maybe<Scalars['String']>;
  usagePlanId: Scalars['String'];
  number: Scalars['String'];
  customer: Scalars['String'];
  customerId: Scalars['String'];
  serviceType: Scalars['String'];
  productType: Scalars['String'];
  customerReference?: Maybe<Scalars['String']>;
  contractTerm: Scalars['Int'];
  billingStatus: Scalars['String'];
  isSmartNumber: Scalars['Boolean'];
  monthlyCharge: Scalars['Float'];
  relatedService: Scalars['String'];
  relatedServiceId: Scalars['String'];
  answerPoint: Scalars['String'];
  contractEnd?: Maybe<Scalars['String']>;
  billingStartDate?: Maybe<Scalars['String']>;
  billingEndDate?: Maybe<Scalars['String']>;
  currentStatus: Scalars['String'];
  dateAdded: Scalars['String'];
  username: Scalars['String'];
  password: Scalars['String'];
  twilioNumberId: Scalars['String'];
  twilioCallFlowId: Scalars['String'];
  twilioSmsFlowId: Scalars['String'];
  twilioFaxFlowId: Scalars['String'];
  twilioCapabilities: ServiceTwilioCapabilities;
  customerIp?: Maybe<Scalars['String']>;
  subnetMask?: Maybe<Scalars['String']>;
  gatewayIp?: Maybe<Scalars['String']>;
  primaryDns?: Maybe<Scalars['String']>;
  secondaryDns?: Maybe<Scalars['String']>;
  cpeType?: Maybe<Scalars['String']>;
  ntuPort?: Maybe<Scalars['String']>;
  ntdSerial?: Maybe<Scalars['String']>;
  simNumber?: Maybe<Scalars['String']>;
  nbnDisconnectionDate?: Maybe<Scalars['String']>;
  nbnLocationId?: Maybe<Scalars['String']>;
  lastBatteryReplacementDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  liftGatewayCases?: Maybe<Scalars['String']>;
  portaAccount?: Maybe<Scalars['String']>;
  portaExtension?: Maybe<Scalars['String']>;
  portaHuntGroup?: Maybe<Scalars['String']>;
  phoneSystem?: Maybe<Scalars['String']>;
  phoneSystemId?: Maybe<Scalars['String']>;
  flowId?: Maybe<Scalars['String']>;
  billingAccount?: Maybe<BillingAccount>;
  twilioCallFlow?: Maybe<Flow>;
  twilioSmsFlow?: Maybe<Flow>;
  twilioFaxFlow?: Maybe<Flow>;
};

export type RecordingListResponse = {
  __typename?: 'RecordingListResponse';
  totalResults: Scalars['Int'];
  totalPages: Scalars['Int'];
  page: Scalars['Int'];
  limit: Scalars['Int'];
  results: Array<Recording>;
};

export type Recording = {
  __typename?: 'Recording';
  id: Scalars['ID'];
  ban: Scalars['String'];
  serviceId: Scalars['String'];
  callSid: Scalars['String'];
  conferenceSid: Scalars['String'];
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  startTime: Scalars['String'];
  duration: Scalars['Float'];
  sid: Scalars['String'];
  price: Scalars['Float'];
  priceUnit: Scalars['String'];
  status: Scalars['String'];
  channels: Scalars['String'];
  source: Scalars['String'];
  transcriptions: Array<Transcription>;
  billingAccount?: Maybe<BillingAccount>;
  service?: Maybe<Service>;
  twilioCall?: Maybe<TwilioCall>;
};

export type Transcription = {
  __typename?: 'Transcription';
  accountSid: Scalars['String'];
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  duration: Scalars['String'];
  price: Scalars['String'];
  priceUnit: Scalars['String'];
  recordingSid: Scalars['String'];
  sid: Scalars['String'];
  status: Scalars['String'];
  transcriptionText: Scalars['String'];
  type: Scalars['String'];
};

export type TwilioCall = {
  __typename?: 'TwilioCall';
  accountSid: Scalars['String'];
  annotation: Scalars['String'];
  answeredBy: Scalars['String'];
  callerName: Scalars['String'];
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  direction: Scalars['String'];
  duration: Scalars['Int'];
  endTime: Scalars['String'];
  forwardedFrom: Scalars['String'];
  from: Scalars['String'];
  fromFormatted: Scalars['String'];
  groupSid: Scalars['String'];
  parentCallSid: Scalars['String'];
  phoneNumberSid: Scalars['String'];
  sid: Scalars['String'];
  startTime: Scalars['String'];
  status: Scalars['String'];
  to: Scalars['String'];
  toFormatted: Scalars['String'];
  contact?: Maybe<Contact>;
};

export type PhoneSystem = {
  __typename?: 'PhoneSystem';
  id: Scalars['ID'];
  name: Scalars['String'];
  billingAccount: Scalars['String'];
  billingAccountId: Scalars['String'];
  usagePlan: Scalars['String'];
  usagePlanId: Scalars['String'];
  portOneCustomerId: Scalars['String'];
  extensions: Array<PhoneSystemExtension>;
  numbers: Array<PhoneSystemNumber>;
  huntGroups: Array<PhoneSystemHuntGroup>;
};

export type PhoneSystemExtension = {
  __typename?: 'PhoneSystemExtension';
  id: Scalars['ID'];
  ban: Scalars['String'];
  usagePlan: Scalars['String'];
  usagePlanId: Scalars['String'];
  number: Scalars['String'];
  customer: Scalars['String'];
  customerId: Scalars['String'];
  serviceType: Scalars['String'];
  productType: Scalars['String'];
  customerReference?: Maybe<Scalars['String']>;
  contractTerm: Scalars['Int'];
  billingStatus: Scalars['String'];
  isSmartNumber: Scalars['Boolean'];
  monthlyCharge: Scalars['Float'];
  relatedService: Scalars['String'];
  relatedServiceId: Scalars['String'];
  answerPoint: Scalars['String'];
  contractEnd?: Maybe<Scalars['String']>;
  billingStartDate: Scalars['String'];
  billingEndDate?: Maybe<Scalars['String']>;
  currentStatus: Scalars['String'];
  dateAdded: Scalars['String'];
  username: Scalars['String'];
  password: Scalars['String'];
  twilioNumberId: Scalars['String'];
  twilioCallFlowId: Scalars['String'];
  twilioSmsFlowId: Scalars['String'];
  twilioFaxFlowId: Scalars['String'];
  twilioCapabilities: ServiceTwilioCapabilities;
  customerIp?: Maybe<Scalars['String']>;
  subnetMask?: Maybe<Scalars['String']>;
  gatewayIp?: Maybe<Scalars['String']>;
  primaryDns?: Maybe<Scalars['String']>;
  secondaryDns?: Maybe<Scalars['String']>;
  cpeType?: Maybe<Scalars['String']>;
  ntuPort?: Maybe<Scalars['String']>;
  ntdSerial?: Maybe<Scalars['String']>;
  simNumber?: Maybe<Scalars['String']>;
  nbnDisconnectionDate?: Maybe<Scalars['String']>;
  nbnLocationId?: Maybe<Scalars['String']>;
  lastBatteryReplacementDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  liftGatewayCases?: Maybe<Scalars['String']>;
  portaAccount?: Maybe<Scalars['String']>;
  portaExtension: Scalars['String'];
  portaHuntGroup?: Maybe<Scalars['String']>;
  phoneSystem?: Maybe<Scalars['String']>;
  phoneSystemId: Scalars['String'];
  flowId?: Maybe<Scalars['String']>;
  billingAccount?: Maybe<BillingAccount>;
  twilioCallFlow?: Maybe<Flow>;
  twilioSmsFlow?: Maybe<Flow>;
  twilioFaxFlow?: Maybe<Flow>;
  portaDisplayNumber?: Maybe<Scalars['String']>;
  huntGroupIds: Array<Scalars['String']>;
  longNumber: Scalars['String'];
  phoneSystemData: PhoneSystem;
  huntGroups: PhoneSystemHuntGroup;
};

export type PhoneSystemHuntGroup = {
  __typename?: 'PhoneSystemHuntGroup';
  id: Scalars['ID'];
  ban: Scalars['String'];
  usagePlan: Scalars['String'];
  usagePlanId: Scalars['String'];
  number: Scalars['String'];
  customer: Scalars['String'];
  customerId: Scalars['String'];
  serviceType: Scalars['String'];
  productType: Scalars['String'];
  customerReference?: Maybe<Scalars['String']>;
  contractTerm: Scalars['Int'];
  billingStatus: Scalars['String'];
  isSmartNumber: Scalars['Boolean'];
  monthlyCharge: Scalars['Float'];
  relatedService: Scalars['String'];
  relatedServiceId: Scalars['String'];
  answerPoint: Scalars['String'];
  contractEnd?: Maybe<Scalars['String']>;
  billingStartDate: Scalars['String'];
  billingEndDate?: Maybe<Scalars['String']>;
  currentStatus: Scalars['String'];
  dateAdded: Scalars['String'];
  username: Scalars['String'];
  password: Scalars['String'];
  twilioNumberId: Scalars['String'];
  twilioCallFlowId: Scalars['String'];
  twilioSmsFlowId: Scalars['String'];
  twilioFaxFlowId: Scalars['String'];
  twilioCapabilities: ServiceTwilioCapabilities;
  customerIp?: Maybe<Scalars['String']>;
  subnetMask?: Maybe<Scalars['String']>;
  gatewayIp?: Maybe<Scalars['String']>;
  primaryDns?: Maybe<Scalars['String']>;
  secondaryDns?: Maybe<Scalars['String']>;
  cpeType?: Maybe<Scalars['String']>;
  ntuPort?: Maybe<Scalars['String']>;
  ntdSerial?: Maybe<Scalars['String']>;
  simNumber?: Maybe<Scalars['String']>;
  nbnDisconnectionDate?: Maybe<Scalars['String']>;
  nbnLocationId?: Maybe<Scalars['String']>;
  lastBatteryReplacementDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  liftGatewayCases?: Maybe<Scalars['String']>;
  portaAccount?: Maybe<Scalars['String']>;
  portaExtension?: Maybe<Scalars['String']>;
  portaHuntGroup: Scalars['String'];
  phoneSystem?: Maybe<Scalars['String']>;
  phoneSystemId: Scalars['String'];
  flowId?: Maybe<Scalars['String']>;
  billingAccount?: Maybe<BillingAccount>;
  twilioCallFlow?: Maybe<Flow>;
  twilioSmsFlow?: Maybe<Flow>;
  twilioFaxFlow?: Maybe<Flow>;
  portaHuntSequence?: Maybe<Scalars['String']>;
  extensionIds: Array<Scalars['String']>;
  phoneSystemData: PhoneSystem;
  extensions: PhoneSystemExtension;
};

export type PhoneSystemNumber = {
  __typename?: 'PhoneSystemNumber';
  id: Scalars['ID'];
  ban: Scalars['String'];
  usagePlan: Scalars['String'];
  usagePlanId: Scalars['String'];
  number: Scalars['String'];
  customer: Scalars['String'];
  customerId: Scalars['String'];
  serviceType: Scalars['String'];
  productType: Scalars['String'];
  customerReference?: Maybe<Scalars['String']>;
  contractTerm: Scalars['Int'];
  billingStatus: Scalars['String'];
  isSmartNumber: Scalars['Boolean'];
  monthlyCharge: Scalars['Float'];
  relatedService: Scalars['String'];
  relatedServiceId: Scalars['String'];
  answerPoint: Scalars['String'];
  contractEnd?: Maybe<Scalars['String']>;
  billingStartDate: Scalars['String'];
  billingEndDate?: Maybe<Scalars['String']>;
  currentStatus: Scalars['String'];
  dateAdded: Scalars['String'];
  username: Scalars['String'];
  password: Scalars['String'];
  twilioNumberId: Scalars['String'];
  twilioCallFlowId: Scalars['String'];
  twilioSmsFlowId: Scalars['String'];
  twilioFaxFlowId: Scalars['String'];
  twilioCapabilities: ServiceTwilioCapabilities;
  customerIp?: Maybe<Scalars['String']>;
  subnetMask?: Maybe<Scalars['String']>;
  gatewayIp?: Maybe<Scalars['String']>;
  primaryDns?: Maybe<Scalars['String']>;
  secondaryDns?: Maybe<Scalars['String']>;
  cpeType?: Maybe<Scalars['String']>;
  ntuPort?: Maybe<Scalars['String']>;
  ntdSerial?: Maybe<Scalars['String']>;
  simNumber?: Maybe<Scalars['String']>;
  nbnDisconnectionDate?: Maybe<Scalars['String']>;
  nbnLocationId?: Maybe<Scalars['String']>;
  lastBatteryReplacementDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  liftGatewayCases?: Maybe<Scalars['String']>;
  portaAccount: Scalars['String'];
  portaExtension?: Maybe<Scalars['String']>;
  portaHuntGroup?: Maybe<Scalars['String']>;
  phoneSystem?: Maybe<Scalars['String']>;
  phoneSystemId: Scalars['String'];
  flowId?: Maybe<Scalars['String']>;
  billingAccount?: Maybe<BillingAccount>;
  twilioCallFlow?: Maybe<Flow>;
  twilioSmsFlow?: Maybe<Flow>;
  twilioFaxFlow?: Maybe<Flow>;
  phoneSystemData: PhoneSystem;
  flow?: Maybe<Flow>;
};

export type PhoneSystemNumberDid = {
  __typename?: 'PhoneSystemNumberDID';
  id: Scalars['String'];
  number: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  country: Scalars['String'];
};

export type UsagePlan = {
  __typename?: 'UsagePlan';
  id: Scalars['String'];
  name: Scalars['String'];
  alias: Scalars['String'];
  status: Scalars['String'];
  type: Scalars['String'];
  monthlyCharge: Scalars['Float'];
  contractTerm: Scalars['String'];
  margin: Scalars['Float'];
  productLine: Scalars['String'];
  isSelfService: Scalars['Boolean'];
  inboundVoiceMinutes: Scalars['Float'];
  outboundVoiceMinutes: Scalars['Float'];
  recordings: Scalars['Float'];
  transcriptions: Scalars['Float'];
  standardInboundSms: Scalars['Float'];
  standardOutboundSms: Scalars['Float'];
  simultaneousCallsLimit?: Maybe<Scalars['Int']>;
  maxExtensions?: Maybe<Scalars['Int']>;
  maxHuntGroups?: Maybe<Scalars['Int']>;
  maxDIDNumbers?: Maybe<Scalars['Int']>;
  max1300Numbers?: Maybe<Scalars['Int']>;
  internationalDirectDial: Scalars['Boolean'];
};

export type MobileServiceNumber = {
  __typename?: 'MobileServiceNumber';
  id: Scalars['String'];
  number: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  country: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  messageSend: Message;
  messageSendMultiple: Array<Message>;
  contactUpdate: Contact;
  recordingDelete: ResponseMessage;
  /** Create a phone system and associated sub entities */
  phoneSystemCreate: PhoneSystem;
  /** Delete a phone system */
  phoneSystemDelete: Scalars['Boolean'];
  /** Update a phone system */
  phoneSystemUpdate: PhoneSystem;
  /** Create a phone system extension */
  phoneSystemExtensionCreate: PhoneSystemExtension;
  /** Delete a phone system extension */
  phoneSystemExtensionDelete: Scalars['Boolean'];
  /** Update a phone system extension */
  phoneSystemExtensionUpdate: PhoneSystemExtension;
  /** Create a phone system hunt group */
  phoneSystemHuntGroupCreate: PhoneSystemHuntGroup;
  /** Delete a phone system hunt group */
  phoneSystemHuntGroupDelete: Scalars['Boolean'];
  /** Update a phone system hunt group */
  phoneSystemHuntGroupUpdate: PhoneSystemHuntGroup;
  /** Create a phone system number */
  phoneSystemNumberCreate: PhoneSystemNumber;
  /** Delete a phone system number */
  phoneSystemNumberDelete: Scalars['Boolean'];
  /** Update a phone system number */
  phoneSystemNumberUpdate: PhoneSystemNumber;
  /** Create mobile service */
  mobileServiceCreate: CreateMobileServiceResponse;
};


export type MutationMessageSendArgs = {
  to: Scalars['String'];
  body: Scalars['String'];
  serviceId: Scalars['String'];
};


export type MutationMessageSendMultipleArgs = {
  to: Array<Scalars['String']>;
  body: Scalars['String'];
  serviceId: Scalars['String'];
};


export type MutationContactUpdateArgs = {
  id: Scalars['ID'];
  created: Scalars['String'];
  lastEdited: Scalars['String'];
  lastActive: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Scalars['String']>>;
  customFields?: Maybe<Scalars['JSONObject']>;
  tags?: Maybe<Array<Scalars['String']>>;
};


export type MutationRecordingDeleteArgs = {
  recordingId: Scalars['String'];
};


export type MutationPhoneSystemCreateArgs = {
  didNumbers: Array<Scalars['String']>;
  ban: Scalars['String'];
  usagePlanAlias: Scalars['String'];
  name: Scalars['String'];
};


export type MutationPhoneSystemDeleteArgs = {
  phoneSystemId: Scalars['String'];
};


export type MutationPhoneSystemUpdateArgs = {
  usagePlanAlias: Scalars['String'];
  name: Scalars['String'];
  phoneSystemId: Scalars['String'];
};


export type MutationPhoneSystemExtensionCreateArgs = {
  name: Scalars['String'];
  number: Scalars['String'];
  phoneSystemId: Scalars['String'];
};


export type MutationPhoneSystemExtensionDeleteArgs = {
  extensionId: Scalars['String'];
};


export type MutationPhoneSystemExtensionUpdateArgs = {
  displayNumber: Scalars['String'];
  number: Scalars['String'];
  name: Scalars['String'];
  extensionId: Scalars['String'];
};


export type MutationPhoneSystemHuntGroupCreateArgs = {
  number: Scalars['String'];
  name: Scalars['String'];
  extensionIds: Array<Scalars['String']>;
  phoneSystemId: Scalars['String'];
};


export type MutationPhoneSystemHuntGroupDeleteArgs = {
  huntGroupId: Scalars['String'];
};


export type MutationPhoneSystemHuntGroupUpdateArgs = {
  huntSequence: Scalars['String'];
  number: Scalars['String'];
  name: Scalars['String'];
  extensionIds: Array<Scalars['String']>;
  huntGroupId: Scalars['String'];
};


export type MutationPhoneSystemNumberCreateArgs = {
  flowId: Scalars['String'];
  customerReference: Scalars['String'];
  number: Scalars['String'];
  phoneSystemId: Scalars['String'];
};


export type MutationPhoneSystemNumberDeleteArgs = {
  phoneSystemNumberId: Scalars['String'];
};


export type MutationPhoneSystemNumberUpdateArgs = {
  customerReference: Scalars['String'];
  flowId: Scalars['String'];
  phoneSystemNumberId: Scalars['String'];
};


export type MutationMobileServiceCreateArgs = {
  endUserType?: Maybe<Scalars['String']>;
  isPremiumNumber?: Maybe<Scalars['Boolean']>;
  usagePlanAlias?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Scalars['String']>>;
  number: Scalars['String'];
  ban: Scalars['String'];
};

export type ResponseMessage = {
  __typename?: 'ResponseMessage';
  message: Scalars['String'];
};

export type CreateMobileServiceResponse = {
  __typename?: 'CreateMobileServiceResponse';
  service: MobileService;
  case?: Maybe<Case>;
};

export type MobileService = {
  __typename?: 'MobileService';
  id: Scalars['ID'];
  ban: Scalars['String'];
  usagePlan: Scalars['String'];
  usagePlanId: Scalars['String'];
  number: Scalars['String'];
  customer: Scalars['String'];
  customerId: Scalars['String'];
  serviceType: Scalars['String'];
  productType: Scalars['String'];
  customerReference?: Maybe<Scalars['String']>;
  contractTerm: Scalars['Int'];
  billingStatus: Scalars['String'];
  isSmartNumber: Scalars['Boolean'];
  monthlyCharge: Scalars['Float'];
  relatedService: Scalars['String'];
  relatedServiceId: Scalars['String'];
  answerPoint: Scalars['String'];
  contractEnd?: Maybe<Scalars['String']>;
  billingStartDate: Scalars['String'];
  billingEndDate?: Maybe<Scalars['String']>;
  currentStatus: Scalars['String'];
  dateAdded: Scalars['String'];
  username: Scalars['String'];
  password: Scalars['String'];
  twilioNumberId: Scalars['String'];
  twilioCallFlowId: Scalars['String'];
  twilioSmsFlowId: Scalars['String'];
  twilioFaxFlowId: Scalars['String'];
  twilioCapabilities: ServiceTwilioCapabilities;
  customerIp?: Maybe<Scalars['String']>;
  subnetMask?: Maybe<Scalars['String']>;
  gatewayIp?: Maybe<Scalars['String']>;
  primaryDns?: Maybe<Scalars['String']>;
  secondaryDns?: Maybe<Scalars['String']>;
  cpeType?: Maybe<Scalars['String']>;
  ntuPort?: Maybe<Scalars['String']>;
  ntdSerial?: Maybe<Scalars['String']>;
  simNumber?: Maybe<Scalars['String']>;
  nbnDisconnectionDate?: Maybe<Scalars['String']>;
  nbnLocationId?: Maybe<Scalars['String']>;
  lastBatteryReplacementDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  liftGatewayCases?: Maybe<Scalars['String']>;
  portaAccount?: Maybe<Scalars['String']>;
  portaExtension?: Maybe<Scalars['String']>;
  portaHuntGroup?: Maybe<Scalars['String']>;
  phoneSystem?: Maybe<Scalars['String']>;
  phoneSystemId?: Maybe<Scalars['String']>;
  flowId?: Maybe<Scalars['String']>;
  billingAccount?: Maybe<BillingAccount>;
  twilioCallFlow?: Maybe<Flow>;
  twilioSmsFlow?: Maybe<Flow>;
  twilioFaxFlow?: Maybe<Flow>;
};

export type Case = {
  __typename?: 'Case';
  id: Scalars['ID'];
  plannedDeliveryDate: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  messageNew: Message;
  callNew: CallsListResponse;
};


export type SubscriptionCallNewArgs = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
  filterDate?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
};

export type GetBillingBillsQueryVariables = Exact<{
  page: Scalars['Float'];
  ban?: Maybe<Scalars['String']>;
}>;


export type GetBillingBillsQuery = (
  { __typename?: 'Query' }
  & { billingBills: (
    { __typename?: 'BillListResponse' }
    & Pick<BillListResponse, 'totalPages'>
    & { results: Array<(
      { __typename?: 'Bill' }
      & Pick<Bill, 'id' | 'billNumber' | 'reference' | 'ban' | 'dueDate' | 'amountDue' | 'total' | 'status'>
      & { documents: Array<(
        { __typename?: 'BillDocument' }
        & Pick<BillDocument, 'fileName'>
      )> }
    )> }
  ) }
);

export type GetBillingPaymentsQueryVariables = Exact<{
  page: Scalars['Float'];
  ban?: Maybe<Scalars['String']>;
}>;


export type GetBillingPaymentsQuery = (
  { __typename?: 'Query' }
  & { billingPayments: (
    { __typename?: 'PaymentListResponse' }
    & Pick<PaymentListResponse, 'totalPages'>
    & { results: Array<(
      { __typename?: 'Payment' }
      & Pick<Payment, 'id' | 'date' | 'billNumber' | 'reference' | 'amount' | 'ban'>
    )> }
  ) }
);

export type ContactUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  created: Scalars['String'];
  lastEdited: Scalars['String'];
  lastActive: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Scalars['String']>>;
  customFields?: Maybe<Scalars['JSONObject']>;
  tags?: Maybe<Array<Scalars['String']>>;
}>;


export type ContactUpdateMutation = (
  { __typename?: 'Mutation' }
  & { contactUpdate: (
    { __typename?: 'Contact' }
    & Pick<Contact, 'id' | 'created' | 'lastEdited' | 'lastActive' | 'userId' | 'firstName' | 'lastName' | 'company' | 'email' | 'phoneNumbers' | 'customFields' | 'tags'>
  ) }
);

export type GetContactQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetContactQuery = (
  { __typename?: 'Query' }
  & { contact: (
    { __typename?: 'Contact' }
    & Pick<Contact, 'id' | 'created' | 'lastEdited' | 'lastActive' | 'userId' | 'firstName' | 'lastName' | 'company' | 'email' | 'phoneNumbers' | 'customFields' | 'tags'>
    & { flowLogs?: Maybe<(
      { __typename?: 'FlowLogListResponse' }
      & { results: Array<(
        { __typename?: 'FlowLog' }
        & Pick<FlowLog, 'id' | 'created' | 'flowId'>
        & { flow?: Maybe<(
          { __typename?: 'Flow' }
          & Pick<Flow, 'name'>
        )> }
      )> }
    )>, messages?: Maybe<(
      { __typename?: 'MessageListResponse' }
      & { results: Array<(
        { __typename?: 'Message' }
        & Pick<Message, 'id' | 'dateSent' | 'serviceId' | 'number' | 'otherNumber'>
      )> }
    )> }
  ) }
);

export type GetContactsQueryVariables = Exact<{
  page: Scalars['Float'];
  search?: Maybe<Scalars['String']>;
}>;


export type GetContactsQuery = (
  { __typename?: 'Query' }
  & { contacts: (
    { __typename?: 'ContactListResponse' }
    & Pick<ContactListResponse, 'totalPages'>
    & { results: Array<(
      { __typename?: 'Contact' }
      & Pick<Contact, 'id' | 'lastActive' | 'firstName' | 'lastName' | 'company' | 'phoneNumbers'>
      & { flowLogs?: Maybe<(
        { __typename?: 'FlowLogListResponse' }
        & Pick<FlowLogListResponse, 'totalResults'>
      )> }
    )> }
  ) }
);

export type GetInternetServiceQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetInternetServiceQuery = (
  { __typename?: 'Query' }
  & { internetService: (
    { __typename?: 'InternetService' }
    & Pick<InternetService, 'id' | 'serviceType' | 'usagePlan' | 'customerReference' | 'ban' | 'number' | 'billingStatus' | 'billingStartDate' | 'billingEndDate' | 'monthlyCharge' | 'contractEnd' | 'currentStatus' | 'customerIp' | 'subnetMask' | 'gatewayIp' | 'primaryDns' | 'secondaryDns' | 'cpeType'>
  ) }
);

export type GetInternetServicesQueryVariables = Exact<{
  page: Scalars['Float'];
  type?: Maybe<Array<Scalars['String']>>;
}>;


export type GetInternetServicesQuery = (
  { __typename?: 'Query' }
  & { internetServices: (
    { __typename?: 'InternetServiceListResponse' }
    & Pick<InternetServiceListResponse, 'totalPages'>
    & { results: Array<(
      { __typename?: 'InternetService' }
      & Pick<InternetService, 'id' | 'serviceType' | 'number' | 'usagePlan' | 'billingStatus' | 'customerReference'>
    )> }
  ) }
);

export type ListMessageThreadQueryVariables = Exact<{
  serviceId: Scalars['String'];
  otherNumber: Scalars['String'];
}>;


export type ListMessageThreadQuery = (
  { __typename?: 'Query' }
  & { messageThread: (
    { __typename?: 'MessageThread' }
    & Pick<MessageThread, 'id' | 'number' | 'otherNumber'>
    & { service?: Maybe<(
      { __typename?: 'Service' }
      & Pick<Service, 'id' | 'number' | 'ban' | 'twilioSmsFlowId'>
    )>, messages: Array<(
      { __typename?: 'Message' }
      & Pick<Message, 'id' | 'to' | 'from' | 'body' | 'dateSent'>
    )>, contact?: Maybe<(
      { __typename?: 'Contact' }
      & Pick<Contact, 'id' | 'firstName' | 'lastName' | 'company' | 'email' | 'userId' | 'phoneNumbers'>
    )> }
  ) }
);

export type ListMessageThreadsQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
}>;


export type ListMessageThreadsQuery = (
  { __typename?: 'Query' }
  & { messageThreads: Array<(
    { __typename?: 'MessageThread' }
    & Pick<MessageThread, 'id' | 'serviceId' | 'number' | 'otherNumber'>
    & { lastMessage: (
      { __typename?: 'Message' }
      & Pick<Message, 'id' | 'body' | 'dateSent'>
    ), contact?: Maybe<(
      { __typename?: 'Contact' }
      & Pick<Contact, 'id' | 'firstName' | 'lastName'>
    )> }
  )> }
);

export type ListSmsServicesQueryVariables = {};


export type ListSmsServicesQuery = (
  { __typename?: 'Query' }
  & { numbers: Array<(
    { __typename?: 'Service' }
    & Pick<Service, 'id' | 'number' | 'customerReference'>
  )> }
);

export type MessageSendMutationVariables = Exact<{
  serviceId: Scalars['String'];
  body: Scalars['String'];
  to: Scalars['String'];
}>;


export type MessageSendMutation = (
  { __typename?: 'Mutation' }
  & { messageSend: (
    { __typename?: 'Message' }
    & Pick<Message, 'id' | 'to' | 'from' | 'body' | 'dateSent'>
  ) }
);

export type MessageSendMultipleMutationVariables = Exact<{
  serviceId: Scalars['String'];
  body: Scalars['String'];
  to: Array<Scalars['String']>;
}>;


export type MessageSendMultipleMutation = (
  { __typename?: 'Mutation' }
  & { messageSendMultiple: Array<(
    { __typename?: 'Message' }
    & Pick<Message, 'id'>
  )> }
);

export type CreateMobileServiceMutationVariables = Exact<{
  ban: Scalars['String'];
  number: Scalars['String'];
  documents?: Maybe<Array<Scalars['String']>>;
  usagePlanAlias?: Maybe<Scalars['String']>;
  isPremiumNumber?: Maybe<Scalars['Boolean']>;
  endUserType?: Maybe<Scalars['String']>;
}>;


export type CreateMobileServiceMutation = (
  { __typename?: 'Mutation' }
  & { mobileServiceCreate: (
    { __typename?: 'CreateMobileServiceResponse' }
    & { service: (
      { __typename?: 'MobileService' }
      & Pick<MobileService, 'id' | 'number' | 'monthlyCharge'>
    ), case?: Maybe<(
      { __typename?: 'Case' }
      & Pick<Case, 'id' | 'plannedDeliveryDate'>
    )> }
  ) }
);

export type SearchMobileServiceNumbersQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchMobileServiceNumbersQuery = (
  { __typename?: 'Query' }
  & { searchMobileServiceNumbers: Array<(
    { __typename?: 'MobileServiceNumber' }
    & Pick<MobileServiceNumber, 'id' | 'number' | 'city' | 'country'>
  )> }
);

export type GetPhoneLineQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPhoneLineQuery = (
  { __typename?: 'Query' }
  & { phoneLine: (
    { __typename?: 'PhoneLine' }
    & Pick<PhoneLine, 'id' | 'serviceType' | 'usagePlan' | 'customerReference' | 'ban' | 'number' | 'billingStatus' | 'billingStartDate' | 'billingEndDate' | 'monthlyCharge' | 'contractEnd' | 'currentStatus' | 'cpeType' | 'ntuPort' | 'ntdSerial' | 'simNumber' | 'nbnDisconnectionDate' | 'nbnLocationId' | 'lastBatteryReplacementDate' | 'description'>
  ) }
);

export type GetPhoneLinesServicesQueryVariables = Exact<{
  page: Scalars['Float'];
  type?: Maybe<Array<Scalars['String']>>;
  ban?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
}>;


export type GetPhoneLinesServicesQuery = (
  { __typename?: 'Query' }
  & { phoneLines: (
    { __typename?: 'PhoneLineListResponse' }
    & Pick<PhoneLineListResponse, 'totalPages'>
    & { results: Array<(
      { __typename?: 'PhoneLine' }
      & Pick<PhoneLine, 'id' | 'serviceType' | 'currentStatus' | 'customerReference' | 'ban' | 'number' | 'cpeType'>
    )> }
  ) }
);

export type CreatePhoneSystemMutationVariables = Exact<{
  name: Scalars['String'];
  usagePlanAlias: Scalars['String'];
  ban: Scalars['String'];
  didNumbers: Array<Scalars['String']>;
}>;


export type CreatePhoneSystemMutation = (
  { __typename?: 'Mutation' }
  & { phoneSystemCreate: (
    { __typename?: 'PhoneSystem' }
    & Pick<PhoneSystem, 'id'>
  ) }
);

export type CreatePhoneSystemExtensionMutationVariables = Exact<{
  name: Scalars['String'];
  number: Scalars['String'];
  phoneSystemId: Scalars['String'];
}>;


export type CreatePhoneSystemExtensionMutation = (
  { __typename?: 'Mutation' }
  & { phoneSystemExtensionCreate: (
    { __typename?: 'PhoneSystemExtension' }
    & Pick<PhoneSystemExtension, 'id' | 'number' | 'customerReference' | 'portaDisplayNumber'>
  ) }
);

export type CreatePhoneSystemHuntGroupMutationVariables = Exact<{
  phoneSystemId: Scalars['String'];
  extensionIds: Array<Scalars['String']>;
  name: Scalars['String'];
  number: Scalars['String'];
}>;


export type CreatePhoneSystemHuntGroupMutation = (
  { __typename?: 'Mutation' }
  & { phoneSystemHuntGroupCreate: (
    { __typename?: 'PhoneSystemHuntGroup' }
    & Pick<PhoneSystemHuntGroup, 'id'>
  ) }
);

export type CreatePhoneSystemNumberMutationVariables = Exact<{
  phoneSystemId: Scalars['String'];
  number: Scalars['String'];
  customerReference: Scalars['String'];
  flowId: Scalars['String'];
}>;


export type CreatePhoneSystemNumberMutation = (
  { __typename?: 'Mutation' }
  & { phoneSystemNumberCreate: (
    { __typename?: 'PhoneSystemNumber' }
    & Pick<PhoneSystemNumber, 'id'>
  ) }
);

export type DeletePhoneSystemMutationVariables = Exact<{
  phoneSystemId: Scalars['String'];
}>;


export type DeletePhoneSystemMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'phoneSystemDelete'>
);

export type DeletePhoneSystemExtensionMutationVariables = Exact<{
  extensionId: Scalars['String'];
}>;


export type DeletePhoneSystemExtensionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'phoneSystemExtensionDelete'>
);

export type DeletePhoneSystemHuntGroupMutationVariables = Exact<{
  huntGroupId: Scalars['String'];
}>;


export type DeletePhoneSystemHuntGroupMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'phoneSystemHuntGroupDelete'>
);

export type DeletePhoneSystemNumberMutationVariables = Exact<{
  phoneSystemNumberId: Scalars['String'];
}>;


export type DeletePhoneSystemNumberMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'phoneSystemNumberDelete'>
);

export type GetPhoneSystemServiceQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPhoneSystemServiceQuery = (
  { __typename?: 'Query' }
  & { phoneSystem: (
    { __typename?: 'PhoneSystem' }
    & Pick<PhoneSystem, 'id' | 'name' | 'usagePlan' | 'usagePlanId' | 'billingAccount'>
    & { extensions: Array<(
      { __typename?: 'PhoneSystemExtension' }
      & Pick<PhoneSystemExtension, 'id' | 'number' | 'longNumber' | 'customerReference' | 'password' | 'portaDisplayNumber'>
    )>, huntGroups: Array<(
      { __typename?: 'PhoneSystemHuntGroup' }
      & Pick<PhoneSystemHuntGroup, 'id' | 'number' | 'customerReference' | 'extensionIds' | 'portaHuntSequence'>
    )>, numbers: Array<(
      { __typename?: 'PhoneSystemNumber' }
      & Pick<PhoneSystemNumber, 'id' | 'number' | 'customerReference'>
      & { flow?: Maybe<(
        { __typename?: 'Flow' }
        & Pick<Flow, 'name' | 'id'>
      )> }
    )> }
  ) }
);

export type GetPhoneSystemExtensionsQueryVariables = Exact<{
  phoneSystemId: Scalars['String'];
}>;


export type GetPhoneSystemExtensionsQuery = (
  { __typename?: 'Query' }
  & { phoneSystemExtensions: Array<(
    { __typename?: 'PhoneSystemExtension' }
    & Pick<PhoneSystemExtension, 'id' | 'number' | 'customerReference' | 'portaDisplayNumber'>
  )> }
);

export type GetPhoneSystemHuntGroupsQueryVariables = Exact<{
  phoneSystemId: Scalars['String'];
}>;


export type GetPhoneSystemHuntGroupsQuery = (
  { __typename?: 'Query' }
  & { phoneSystemHuntGroups: Array<(
    { __typename?: 'PhoneSystemHuntGroup' }
    & Pick<PhoneSystemHuntGroup, 'id' | 'customerReference' | 'extensionIds' | 'number'>
  )> }
);

export type GetPhoneSystemNumbersQueryVariables = Exact<{
  phoneSystemId: Scalars['String'];
}>;


export type GetPhoneSystemNumbersQuery = (
  { __typename?: 'Query' }
  & { phoneSystemNumbers: Array<(
    { __typename?: 'PhoneSystemNumber' }
    & Pick<PhoneSystemNumber, 'id' | 'customerReference' | 'number'>
  )> }
);

export type GetPhoneSystemServicesQueryVariables = {};


export type GetPhoneSystemServicesQuery = (
  { __typename?: 'Query' }
  & { phoneSystems: Array<(
    { __typename?: 'PhoneSystem' }
    & Pick<PhoneSystem, 'id' | 'name' | 'usagePlan' | 'usagePlanId'>
  )> }
);

export type GetUsagePlansQueryVariables = {};


export type GetUsagePlansQuery = (
  { __typename?: 'Query' }
  & { usagePlans: Array<(
    { __typename?: 'UsagePlan' }
    & Pick<UsagePlan, 'id' | 'name' | 'alias' | 'status' | 'type' | 'monthlyCharge' | 'contractTerm' | 'margin' | 'productLine' | 'isSelfService' | 'inboundVoiceMinutes' | 'outboundVoiceMinutes' | 'recordings' | 'transcriptions' | 'standardInboundSms' | 'standardOutboundSms' | 'simultaneousCallsLimit' | 'maxExtensions' | 'maxHuntGroups' | 'maxDIDNumbers' | 'max1300Numbers' | 'internationalDirectDial'>
  )> }
);

export type SearchPhoneSystemDidNumbersQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchPhoneSystemDidNumbersQuery = (
  { __typename?: 'Query' }
  & { searchPhoneSystemDIDNumbers: Array<(
    { __typename?: 'PhoneSystemNumberDID' }
    & Pick<PhoneSystemNumberDid, 'id' | 'number' | 'city' | 'country'>
  )> }
);

export type UpdatePhoneSystemExtensionMutationVariables = Exact<{
  extensionId: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['String'];
  displayNumber: Scalars['String'];
}>;


export type UpdatePhoneSystemExtensionMutation = (
  { __typename?: 'Mutation' }
  & { phoneSystemExtensionUpdate: (
    { __typename?: 'PhoneSystemExtension' }
    & Pick<PhoneSystemExtension, 'id' | 'number' | 'customerReference' | 'portaDisplayNumber'>
  ) }
);

export type UpdatePhoneSystemHuntGroupMutationVariables = Exact<{
  huntGroupId: Scalars['String'];
  extensionIds: Array<Scalars['String']>;
  name: Scalars['String'];
  number: Scalars['String'];
  huntSequence: Scalars['String'];
}>;


export type UpdatePhoneSystemHuntGroupMutation = (
  { __typename?: 'Mutation' }
  & { phoneSystemHuntGroupUpdate: (
    { __typename?: 'PhoneSystemHuntGroup' }
    & Pick<PhoneSystemHuntGroup, 'id' | 'extensionIds' | 'customerReference' | 'number' | 'portaHuntSequence'>
  ) }
);

export type UpdatePhoneSystemNumberMutationVariables = Exact<{
  phoneSystemNumberId: Scalars['String'];
  customerReference: Scalars['String'];
  flowId: Scalars['String'];
}>;


export type UpdatePhoneSystemNumberMutation = (
  { __typename?: 'Mutation' }
  & { phoneSystemNumberUpdate: (
    { __typename?: 'PhoneSystemNumber' }
    & Pick<PhoneSystemNumber, 'id' | 'customerReference'>
  ) }
);

export type ListRecordingsQueryVariables = Exact<{
  page: Scalars['Float'];
  serviceId?: Maybe<Scalars['String']>;
  ban?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
}>;


export type ListRecordingsQuery = (
  { __typename?: 'Query' }
  & { recordings: (
    { __typename?: 'RecordingListResponse' }
    & Pick<RecordingListResponse, 'totalPages'>
    & { results: Array<(
      { __typename?: 'Recording' }
      & Pick<Recording, 'id' | 'serviceId' | 'source' | 'sid' | 'dateCreated'>
      & { transcriptions: Array<(
        { __typename?: 'Transcription' }
        & Pick<Transcription, 'sid'>
      )> }
    )> }
  ) }
);

export type ListCallsQueryVariables = Exact<{
  serviceId?: Maybe<Scalars['String']>;
  page: Scalars['Int'];
  filterDate?: Maybe<Scalars['String']>;
}>;


export type ListCallsQuery = (
  { __typename?: 'Query' }
  & { calls: (
    { __typename?: 'CallsListResponse' }
    & Pick<CallsListResponse, 'totalPages'>
    & { results: Array<(
      { __typename?: 'Call' }
      & Pick<Call, 'dateTime' | 'incomingCaller' | 'answerPoint' | 'location' | 'state' | 'callStatus' | 'duration' | 'target' | 'usageType' | 'amountCharged'>
    )> }
  ) }
);

export type GetRecordingQueryVariables = Exact<{
  recordingId: Scalars['String'];
}>;


export type GetRecordingQuery = (
  { __typename?: 'Query' }
  & { recording: (
    { __typename?: 'Recording' }
    & Pick<Recording, 'id' | 'serviceId' | 'source' | 'sid' | 'dateCreated' | 'duration' | 'status'>
    & { transcriptions: Array<(
      { __typename?: 'Transcription' }
      & Pick<Transcription, 'sid' | 'transcriptionText'>
    )>, twilioCall?: Maybe<(
      { __typename?: 'TwilioCall' }
      & Pick<TwilioCall, 'from'>
      & { contact?: Maybe<(
        { __typename?: 'Contact' }
        & Pick<Contact, 'id' | 'firstName' | 'lastName' | 'company'>
      )> }
    )> }
  ) }
);


export const GetBillingBillsDocument = gql`
    query GetBillingBills($page: Float!, $ban: String) {
  billingBills(page: $page, ban: $ban) {
    totalPages
    results {
      id
      billNumber
      reference
      ban
      dueDate
      amountDue
      total
      status
      documents {
        fileName
      }
    }
  }
}
    `;

/**
 * __useGetBillingBillsQuery__
 *
 * To run a query within a React component, call `useGetBillingBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingBillsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      ban: // value for 'ban'
 *   },
 * });
 */
export function useGetBillingBillsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBillingBillsQuery, GetBillingBillsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBillingBillsQuery, GetBillingBillsQueryVariables>(GetBillingBillsDocument, baseOptions);
      }
export function useGetBillingBillsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBillingBillsQuery, GetBillingBillsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBillingBillsQuery, GetBillingBillsQueryVariables>(GetBillingBillsDocument, baseOptions);
        }
export type GetBillingBillsQueryHookResult = ReturnType<typeof useGetBillingBillsQuery>;
export type GetBillingBillsLazyQueryHookResult = ReturnType<typeof useGetBillingBillsLazyQuery>;
export type GetBillingBillsQueryResult = ApolloReactCommon.QueryResult<GetBillingBillsQuery, GetBillingBillsQueryVariables>;
export const GetBillingPaymentsDocument = gql`
    query GetBillingPayments($page: Float!, $ban: String) {
  billingPayments(page: $page, ban: $ban) {
    totalPages
    results {
      id
      date
      billNumber
      reference
      amount
      ban
    }
  }
}
    `;

/**
 * __useGetBillingPaymentsQuery__
 *
 * To run a query within a React component, call `useGetBillingPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingPaymentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      ban: // value for 'ban'
 *   },
 * });
 */
export function useGetBillingPaymentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBillingPaymentsQuery, GetBillingPaymentsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBillingPaymentsQuery, GetBillingPaymentsQueryVariables>(GetBillingPaymentsDocument, baseOptions);
      }
export function useGetBillingPaymentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBillingPaymentsQuery, GetBillingPaymentsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBillingPaymentsQuery, GetBillingPaymentsQueryVariables>(GetBillingPaymentsDocument, baseOptions);
        }
export type GetBillingPaymentsQueryHookResult = ReturnType<typeof useGetBillingPaymentsQuery>;
export type GetBillingPaymentsLazyQueryHookResult = ReturnType<typeof useGetBillingPaymentsLazyQuery>;
export type GetBillingPaymentsQueryResult = ApolloReactCommon.QueryResult<GetBillingPaymentsQuery, GetBillingPaymentsQueryVariables>;
export const ContactUpdateDocument = gql`
    mutation ContactUpdate($id: ID!, $created: String!, $lastEdited: String!, $lastActive: String!, $userId: String, $firstName: String, $lastName: String, $company: String, $email: String, $phoneNumbers: [String!], $customFields: JSONObject, $tags: [String!]) {
  contactUpdate(id: $id, created: $created, lastEdited: $lastEdited, lastActive: $lastActive, userId: $userId, firstName: $firstName, lastName: $lastName, company: $company, email: $email, phoneNumbers: $phoneNumbers, customFields: $customFields, tags: $tags) {
    id
    created
    lastEdited
    lastActive
    userId
    firstName
    lastName
    company
    email
    phoneNumbers
    customFields
    tags
  }
}
    `;
export type ContactUpdateMutationFn = ApolloReactCommon.MutationFunction<ContactUpdateMutation, ContactUpdateMutationVariables>;

/**
 * __useContactUpdateMutation__
 *
 * To run a mutation, you first call `useContactUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactUpdateMutation, { data, loading, error }] = useContactUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      created: // value for 'created'
 *      lastEdited: // value for 'lastEdited'
 *      lastActive: // value for 'lastActive'
 *      userId: // value for 'userId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      company: // value for 'company'
 *      email: // value for 'email'
 *      phoneNumbers: // value for 'phoneNumbers'
 *      customFields: // value for 'customFields'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useContactUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ContactUpdateMutation, ContactUpdateMutationVariables>) {
        return ApolloReactHooks.useMutation<ContactUpdateMutation, ContactUpdateMutationVariables>(ContactUpdateDocument, baseOptions);
      }
export type ContactUpdateMutationHookResult = ReturnType<typeof useContactUpdateMutation>;
export type ContactUpdateMutationResult = ApolloReactCommon.MutationResult<ContactUpdateMutation>;
export type ContactUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<ContactUpdateMutation, ContactUpdateMutationVariables>;
export const GetContactDocument = gql`
    query GetContact($id: String!) {
  contact(id: $id) {
    id
    created
    lastEdited
    lastActive
    userId
    firstName
    lastName
    company
    email
    phoneNumbers
    customFields
    tags
    flowLogs(page: 1, limit: 5) {
      results {
        id
        created
        flowId
        flow {
          name
        }
      }
    }
    messages(page: 1, limit: 5) {
      results {
        id
        dateSent
        serviceId
        number
        otherNumber
      }
    }
  }
}
    `;

/**
 * __useGetContactQuery__
 *
 * To run a query within a React component, call `useGetContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContactQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
        return ApolloReactHooks.useQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, baseOptions);
      }
export function useGetContactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, baseOptions);
        }
export type GetContactQueryHookResult = ReturnType<typeof useGetContactQuery>;
export type GetContactLazyQueryHookResult = ReturnType<typeof useGetContactLazyQuery>;
export type GetContactQueryResult = ApolloReactCommon.QueryResult<GetContactQuery, GetContactQueryVariables>;
export const GetContactsDocument = gql`
    query GetContacts($page: Float!, $search: String) {
  contacts(page: $page, search: $search) {
    totalPages
    results {
      id
      lastActive
      firstName
      lastName
      company
      phoneNumbers
      flowLogs {
        totalResults
      }
    }
  }
}
    `;

/**
 * __useGetContactsQuery__
 *
 * To run a query within a React component, call `useGetContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetContactsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, baseOptions);
      }
export function useGetContactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, baseOptions);
        }
export type GetContactsQueryHookResult = ReturnType<typeof useGetContactsQuery>;
export type GetContactsLazyQueryHookResult = ReturnType<typeof useGetContactsLazyQuery>;
export type GetContactsQueryResult = ApolloReactCommon.QueryResult<GetContactsQuery, GetContactsQueryVariables>;
export const GetInternetServiceDocument = gql`
    query GetInternetService($id: String!) {
  internetService(id: $id) {
    id
    serviceType
    usagePlan
    customerReference
    ban
    number
    billingStatus
    billingStartDate
    billingEndDate
    monthlyCharge
    contractEnd
    currentStatus
    customerIp
    subnetMask
    gatewayIp
    primaryDns
    secondaryDns
    cpeType
  }
}
    `;

/**
 * __useGetInternetServiceQuery__
 *
 * To run a query within a React component, call `useGetInternetServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInternetServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInternetServiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInternetServiceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInternetServiceQuery, GetInternetServiceQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInternetServiceQuery, GetInternetServiceQueryVariables>(GetInternetServiceDocument, baseOptions);
      }
export function useGetInternetServiceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInternetServiceQuery, GetInternetServiceQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInternetServiceQuery, GetInternetServiceQueryVariables>(GetInternetServiceDocument, baseOptions);
        }
export type GetInternetServiceQueryHookResult = ReturnType<typeof useGetInternetServiceQuery>;
export type GetInternetServiceLazyQueryHookResult = ReturnType<typeof useGetInternetServiceLazyQuery>;
export type GetInternetServiceQueryResult = ApolloReactCommon.QueryResult<GetInternetServiceQuery, GetInternetServiceQueryVariables>;
export const GetInternetServicesDocument = gql`
    query GetInternetServices($page: Float!, $type: [String!]) {
  internetServices(page: $page, type: $type) {
    totalPages
    results {
      id
      serviceType
      number
      usagePlan
      billingStatus
      customerReference
    }
  }
}
    `;

/**
 * __useGetInternetServicesQuery__
 *
 * To run a query within a React component, call `useGetInternetServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInternetServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInternetServicesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetInternetServicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInternetServicesQuery, GetInternetServicesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInternetServicesQuery, GetInternetServicesQueryVariables>(GetInternetServicesDocument, baseOptions);
      }
export function useGetInternetServicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInternetServicesQuery, GetInternetServicesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInternetServicesQuery, GetInternetServicesQueryVariables>(GetInternetServicesDocument, baseOptions);
        }
export type GetInternetServicesQueryHookResult = ReturnType<typeof useGetInternetServicesQuery>;
export type GetInternetServicesLazyQueryHookResult = ReturnType<typeof useGetInternetServicesLazyQuery>;
export type GetInternetServicesQueryResult = ApolloReactCommon.QueryResult<GetInternetServicesQuery, GetInternetServicesQueryVariables>;
export const ListMessageThreadDocument = gql`
    query ListMessageThread($serviceId: String!, $otherNumber: String!) {
  messageThread(serviceId: $serviceId, otherNumber: $otherNumber) {
    id
    number
    otherNumber
    service {
      id
      number
      ban
      twilioSmsFlowId
    }
    messages {
      id
      to
      from
      body
      dateSent
    }
    contact {
      id
      firstName
      lastName
      company
      email
      userId
      phoneNumbers
    }
  }
}
    `;

/**
 * __useListMessageThreadQuery__
 *
 * To run a query within a React component, call `useListMessageThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMessageThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMessageThreadQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      otherNumber: // value for 'otherNumber'
 *   },
 * });
 */
export function useListMessageThreadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListMessageThreadQuery, ListMessageThreadQueryVariables>) {
        return ApolloReactHooks.useQuery<ListMessageThreadQuery, ListMessageThreadQueryVariables>(ListMessageThreadDocument, baseOptions);
      }
export function useListMessageThreadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListMessageThreadQuery, ListMessageThreadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ListMessageThreadQuery, ListMessageThreadQueryVariables>(ListMessageThreadDocument, baseOptions);
        }
export type ListMessageThreadQueryHookResult = ReturnType<typeof useListMessageThreadQuery>;
export type ListMessageThreadLazyQueryHookResult = ReturnType<typeof useListMessageThreadLazyQuery>;
export type ListMessageThreadQueryResult = ApolloReactCommon.QueryResult<ListMessageThreadQuery, ListMessageThreadQueryVariables>;
export const ListMessageThreadsDocument = gql`
    query ListMessageThreads($page: Float!, $limit: Float!) {
  messageThreads(page: $page, limit: $limit) {
    id
    serviceId
    number
    otherNumber
    lastMessage {
      id
      body
      dateSent
    }
    contact {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useListMessageThreadsQuery__
 *
 * To run a query within a React component, call `useListMessageThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMessageThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMessageThreadsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListMessageThreadsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListMessageThreadsQuery, ListMessageThreadsQueryVariables>) {
        return ApolloReactHooks.useQuery<ListMessageThreadsQuery, ListMessageThreadsQueryVariables>(ListMessageThreadsDocument, baseOptions);
      }
export function useListMessageThreadsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListMessageThreadsQuery, ListMessageThreadsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ListMessageThreadsQuery, ListMessageThreadsQueryVariables>(ListMessageThreadsDocument, baseOptions);
        }
export type ListMessageThreadsQueryHookResult = ReturnType<typeof useListMessageThreadsQuery>;
export type ListMessageThreadsLazyQueryHookResult = ReturnType<typeof useListMessageThreadsLazyQuery>;
export type ListMessageThreadsQueryResult = ApolloReactCommon.QueryResult<ListMessageThreadsQuery, ListMessageThreadsQueryVariables>;
export const ListSmsServicesDocument = gql`
    query ListSmsServices {
  numbers(capabilitySms: true) {
    id
    number
    customerReference
  }
}
    `;

/**
 * __useListSmsServicesQuery__
 *
 * To run a query within a React component, call `useListSmsServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSmsServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSmsServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListSmsServicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListSmsServicesQuery, ListSmsServicesQueryVariables>) {
        return ApolloReactHooks.useQuery<ListSmsServicesQuery, ListSmsServicesQueryVariables>(ListSmsServicesDocument, baseOptions);
      }
export function useListSmsServicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListSmsServicesQuery, ListSmsServicesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ListSmsServicesQuery, ListSmsServicesQueryVariables>(ListSmsServicesDocument, baseOptions);
        }
export type ListSmsServicesQueryHookResult = ReturnType<typeof useListSmsServicesQuery>;
export type ListSmsServicesLazyQueryHookResult = ReturnType<typeof useListSmsServicesLazyQuery>;
export type ListSmsServicesQueryResult = ApolloReactCommon.QueryResult<ListSmsServicesQuery, ListSmsServicesQueryVariables>;
export const MessageSendDocument = gql`
    mutation MessageSend($serviceId: String!, $body: String!, $to: String!) {
  messageSend(serviceId: $serviceId, body: $body, to: $to) {
    id
    to
    from
    body
    dateSent
  }
}
    `;
export type MessageSendMutationFn = ApolloReactCommon.MutationFunction<MessageSendMutation, MessageSendMutationVariables>;

/**
 * __useMessageSendMutation__
 *
 * To run a mutation, you first call `useMessageSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageSendMutation, { data, loading, error }] = useMessageSendMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      body: // value for 'body'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useMessageSendMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MessageSendMutation, MessageSendMutationVariables>) {
        return ApolloReactHooks.useMutation<MessageSendMutation, MessageSendMutationVariables>(MessageSendDocument, baseOptions);
      }
export type MessageSendMutationHookResult = ReturnType<typeof useMessageSendMutation>;
export type MessageSendMutationResult = ApolloReactCommon.MutationResult<MessageSendMutation>;
export type MessageSendMutationOptions = ApolloReactCommon.BaseMutationOptions<MessageSendMutation, MessageSendMutationVariables>;
export const MessageSendMultipleDocument = gql`
    mutation MessageSendMultiple($serviceId: String!, $body: String!, $to: [String!]!) {
  messageSendMultiple(serviceId: $serviceId, body: $body, to: $to) {
    id
  }
}
    `;
export type MessageSendMultipleMutationFn = ApolloReactCommon.MutationFunction<MessageSendMultipleMutation, MessageSendMultipleMutationVariables>;

/**
 * __useMessageSendMultipleMutation__
 *
 * To run a mutation, you first call `useMessageSendMultipleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageSendMultipleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageSendMultipleMutation, { data, loading, error }] = useMessageSendMultipleMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      body: // value for 'body'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useMessageSendMultipleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MessageSendMultipleMutation, MessageSendMultipleMutationVariables>) {
        return ApolloReactHooks.useMutation<MessageSendMultipleMutation, MessageSendMultipleMutationVariables>(MessageSendMultipleDocument, baseOptions);
      }
export type MessageSendMultipleMutationHookResult = ReturnType<typeof useMessageSendMultipleMutation>;
export type MessageSendMultipleMutationResult = ApolloReactCommon.MutationResult<MessageSendMultipleMutation>;
export type MessageSendMultipleMutationOptions = ApolloReactCommon.BaseMutationOptions<MessageSendMultipleMutation, MessageSendMultipleMutationVariables>;
export const CreateMobileServiceDocument = gql`
    mutation CreateMobileService($ban: String!, $number: String!, $documents: [String!], $usagePlanAlias: String, $isPremiumNumber: Boolean, $endUserType: String) {
  mobileServiceCreate(ban: $ban, number: $number, documents: $documents, usagePlanAlias: $usagePlanAlias, isPremiumNumber: $isPremiumNumber, endUserType: $endUserType) {
    service {
      id
      number
      monthlyCharge
    }
    case {
      id
      plannedDeliveryDate
    }
  }
}
    `;
export type CreateMobileServiceMutationFn = ApolloReactCommon.MutationFunction<CreateMobileServiceMutation, CreateMobileServiceMutationVariables>;

/**
 * __useCreateMobileServiceMutation__
 *
 * To run a mutation, you first call `useCreateMobileServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMobileServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMobileServiceMutation, { data, loading, error }] = useCreateMobileServiceMutation({
 *   variables: {
 *      ban: // value for 'ban'
 *      number: // value for 'number'
 *      documents: // value for 'documents'
 *      usagePlanAlias: // value for 'usagePlanAlias'
 *      isPremiumNumber: // value for 'isPremiumNumber'
 *      endUserType: // value for 'endUserType'
 *   },
 * });
 */
export function useCreateMobileServiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMobileServiceMutation, CreateMobileServiceMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateMobileServiceMutation, CreateMobileServiceMutationVariables>(CreateMobileServiceDocument, baseOptions);
      }
export type CreateMobileServiceMutationHookResult = ReturnType<typeof useCreateMobileServiceMutation>;
export type CreateMobileServiceMutationResult = ApolloReactCommon.MutationResult<CreateMobileServiceMutation>;
export type CreateMobileServiceMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateMobileServiceMutation, CreateMobileServiceMutationVariables>;
export const SearchMobileServiceNumbersDocument = gql`
    query SearchMobileServiceNumbers($query: String!) {
  searchMobileServiceNumbers(query: $query, limit: 50) {
    id
    number
    city
    country
  }
}
    `;

/**
 * __useSearchMobileServiceNumbersQuery__
 *
 * To run a query within a React component, call `useSearchMobileServiceNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMobileServiceNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMobileServiceNumbersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchMobileServiceNumbersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchMobileServiceNumbersQuery, SearchMobileServiceNumbersQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchMobileServiceNumbersQuery, SearchMobileServiceNumbersQueryVariables>(SearchMobileServiceNumbersDocument, baseOptions);
      }
export function useSearchMobileServiceNumbersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchMobileServiceNumbersQuery, SearchMobileServiceNumbersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchMobileServiceNumbersQuery, SearchMobileServiceNumbersQueryVariables>(SearchMobileServiceNumbersDocument, baseOptions);
        }
export type SearchMobileServiceNumbersQueryHookResult = ReturnType<typeof useSearchMobileServiceNumbersQuery>;
export type SearchMobileServiceNumbersLazyQueryHookResult = ReturnType<typeof useSearchMobileServiceNumbersLazyQuery>;
export type SearchMobileServiceNumbersQueryResult = ApolloReactCommon.QueryResult<SearchMobileServiceNumbersQuery, SearchMobileServiceNumbersQueryVariables>;
export const GetPhoneLineDocument = gql`
    query GetPhoneLine($id: String!) {
  phoneLine(id: $id) {
    id
    serviceType
    usagePlan
    customerReference
    ban
    number
    billingStatus
    billingStartDate
    billingEndDate
    monthlyCharge
    contractEnd
    currentStatus
    cpeType
    ntuPort
    ntdSerial
    simNumber
    nbnDisconnectionDate
    nbnLocationId
    lastBatteryReplacementDate
    description
  }
}
    `;

/**
 * __useGetPhoneLineQuery__
 *
 * To run a query within a React component, call `useGetPhoneLineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhoneLineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhoneLineQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPhoneLineQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPhoneLineQuery, GetPhoneLineQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPhoneLineQuery, GetPhoneLineQueryVariables>(GetPhoneLineDocument, baseOptions);
      }
export function useGetPhoneLineLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPhoneLineQuery, GetPhoneLineQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPhoneLineQuery, GetPhoneLineQueryVariables>(GetPhoneLineDocument, baseOptions);
        }
export type GetPhoneLineQueryHookResult = ReturnType<typeof useGetPhoneLineQuery>;
export type GetPhoneLineLazyQueryHookResult = ReturnType<typeof useGetPhoneLineLazyQuery>;
export type GetPhoneLineQueryResult = ApolloReactCommon.QueryResult<GetPhoneLineQuery, GetPhoneLineQueryVariables>;
export const GetPhoneLinesServicesDocument = gql`
    query GetPhoneLinesServices($page: Float!, $type: [String!], $ban: String, $search: String) {
  phoneLines(page: $page, type: $type, ban: $ban, search: $search) {
    totalPages
    results {
      id
      serviceType
      currentStatus
      customerReference
      ban
      number
      cpeType
    }
  }
}
    `;

/**
 * __useGetPhoneLinesServicesQuery__
 *
 * To run a query within a React component, call `useGetPhoneLinesServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhoneLinesServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhoneLinesServicesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      type: // value for 'type'
 *      ban: // value for 'ban'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPhoneLinesServicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPhoneLinesServicesQuery, GetPhoneLinesServicesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPhoneLinesServicesQuery, GetPhoneLinesServicesQueryVariables>(GetPhoneLinesServicesDocument, baseOptions);
      }
export function useGetPhoneLinesServicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPhoneLinesServicesQuery, GetPhoneLinesServicesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPhoneLinesServicesQuery, GetPhoneLinesServicesQueryVariables>(GetPhoneLinesServicesDocument, baseOptions);
        }
export type GetPhoneLinesServicesQueryHookResult = ReturnType<typeof useGetPhoneLinesServicesQuery>;
export type GetPhoneLinesServicesLazyQueryHookResult = ReturnType<typeof useGetPhoneLinesServicesLazyQuery>;
export type GetPhoneLinesServicesQueryResult = ApolloReactCommon.QueryResult<GetPhoneLinesServicesQuery, GetPhoneLinesServicesQueryVariables>;
export const CreatePhoneSystemDocument = gql`
    mutation CreatePhoneSystem($name: String!, $usagePlanAlias: String!, $ban: String!, $didNumbers: [String!]!) {
  phoneSystemCreate(name: $name, usagePlanAlias: $usagePlanAlias, ban: $ban, didNumbers: $didNumbers) {
    id
  }
}
    `;
export type CreatePhoneSystemMutationFn = ApolloReactCommon.MutationFunction<CreatePhoneSystemMutation, CreatePhoneSystemMutationVariables>;

/**
 * __useCreatePhoneSystemMutation__
 *
 * To run a mutation, you first call `useCreatePhoneSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhoneSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhoneSystemMutation, { data, loading, error }] = useCreatePhoneSystemMutation({
 *   variables: {
 *      name: // value for 'name'
 *      usagePlanAlias: // value for 'usagePlanAlias'
 *      ban: // value for 'ban'
 *      didNumbers: // value for 'didNumbers'
 *   },
 * });
 */
export function useCreatePhoneSystemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePhoneSystemMutation, CreatePhoneSystemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePhoneSystemMutation, CreatePhoneSystemMutationVariables>(CreatePhoneSystemDocument, baseOptions);
      }
export type CreatePhoneSystemMutationHookResult = ReturnType<typeof useCreatePhoneSystemMutation>;
export type CreatePhoneSystemMutationResult = ApolloReactCommon.MutationResult<CreatePhoneSystemMutation>;
export type CreatePhoneSystemMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePhoneSystemMutation, CreatePhoneSystemMutationVariables>;
export const CreatePhoneSystemExtensionDocument = gql`
    mutation CreatePhoneSystemExtension($name: String!, $number: String!, $phoneSystemId: String!) {
  phoneSystemExtensionCreate(name: $name, number: $number, phoneSystemId: $phoneSystemId) {
    id
    number
    customerReference
    portaDisplayNumber
  }
}
    `;
export type CreatePhoneSystemExtensionMutationFn = ApolloReactCommon.MutationFunction<CreatePhoneSystemExtensionMutation, CreatePhoneSystemExtensionMutationVariables>;

/**
 * __useCreatePhoneSystemExtensionMutation__
 *
 * To run a mutation, you first call `useCreatePhoneSystemExtensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhoneSystemExtensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhoneSystemExtensionMutation, { data, loading, error }] = useCreatePhoneSystemExtensionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      number: // value for 'number'
 *      phoneSystemId: // value for 'phoneSystemId'
 *   },
 * });
 */
export function useCreatePhoneSystemExtensionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePhoneSystemExtensionMutation, CreatePhoneSystemExtensionMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePhoneSystemExtensionMutation, CreatePhoneSystemExtensionMutationVariables>(CreatePhoneSystemExtensionDocument, baseOptions);
      }
export type CreatePhoneSystemExtensionMutationHookResult = ReturnType<typeof useCreatePhoneSystemExtensionMutation>;
export type CreatePhoneSystemExtensionMutationResult = ApolloReactCommon.MutationResult<CreatePhoneSystemExtensionMutation>;
export type CreatePhoneSystemExtensionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePhoneSystemExtensionMutation, CreatePhoneSystemExtensionMutationVariables>;
export const CreatePhoneSystemHuntGroupDocument = gql`
    mutation CreatePhoneSystemHuntGroup($phoneSystemId: String!, $extensionIds: [String!]!, $name: String!, $number: String!) {
  phoneSystemHuntGroupCreate(phoneSystemId: $phoneSystemId, extensionIds: $extensionIds, name: $name, number: $number) {
    id
  }
}
    `;
export type CreatePhoneSystemHuntGroupMutationFn = ApolloReactCommon.MutationFunction<CreatePhoneSystemHuntGroupMutation, CreatePhoneSystemHuntGroupMutationVariables>;

/**
 * __useCreatePhoneSystemHuntGroupMutation__
 *
 * To run a mutation, you first call `useCreatePhoneSystemHuntGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhoneSystemHuntGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhoneSystemHuntGroupMutation, { data, loading, error }] = useCreatePhoneSystemHuntGroupMutation({
 *   variables: {
 *      phoneSystemId: // value for 'phoneSystemId'
 *      extensionIds: // value for 'extensionIds'
 *      name: // value for 'name'
 *      number: // value for 'number'
 *   },
 * });
 */
export function useCreatePhoneSystemHuntGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePhoneSystemHuntGroupMutation, CreatePhoneSystemHuntGroupMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePhoneSystemHuntGroupMutation, CreatePhoneSystemHuntGroupMutationVariables>(CreatePhoneSystemHuntGroupDocument, baseOptions);
      }
export type CreatePhoneSystemHuntGroupMutationHookResult = ReturnType<typeof useCreatePhoneSystemHuntGroupMutation>;
export type CreatePhoneSystemHuntGroupMutationResult = ApolloReactCommon.MutationResult<CreatePhoneSystemHuntGroupMutation>;
export type CreatePhoneSystemHuntGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePhoneSystemHuntGroupMutation, CreatePhoneSystemHuntGroupMutationVariables>;
export const CreatePhoneSystemNumberDocument = gql`
    mutation CreatePhoneSystemNumber($phoneSystemId: String!, $number: String!, $customerReference: String!, $flowId: String!) {
  phoneSystemNumberCreate(phoneSystemId: $phoneSystemId, number: $number, customerReference: $customerReference, flowId: $flowId) {
    id
  }
}
    `;
export type CreatePhoneSystemNumberMutationFn = ApolloReactCommon.MutationFunction<CreatePhoneSystemNumberMutation, CreatePhoneSystemNumberMutationVariables>;

/**
 * __useCreatePhoneSystemNumberMutation__
 *
 * To run a mutation, you first call `useCreatePhoneSystemNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhoneSystemNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhoneSystemNumberMutation, { data, loading, error }] = useCreatePhoneSystemNumberMutation({
 *   variables: {
 *      phoneSystemId: // value for 'phoneSystemId'
 *      number: // value for 'number'
 *      customerReference: // value for 'customerReference'
 *      flowId: // value for 'flowId'
 *   },
 * });
 */
export function useCreatePhoneSystemNumberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePhoneSystemNumberMutation, CreatePhoneSystemNumberMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePhoneSystemNumberMutation, CreatePhoneSystemNumberMutationVariables>(CreatePhoneSystemNumberDocument, baseOptions);
      }
export type CreatePhoneSystemNumberMutationHookResult = ReturnType<typeof useCreatePhoneSystemNumberMutation>;
export type CreatePhoneSystemNumberMutationResult = ApolloReactCommon.MutationResult<CreatePhoneSystemNumberMutation>;
export type CreatePhoneSystemNumberMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePhoneSystemNumberMutation, CreatePhoneSystemNumberMutationVariables>;
export const DeletePhoneSystemDocument = gql`
    mutation DeletePhoneSystem($phoneSystemId: String!) {
  phoneSystemDelete(phoneSystemId: $phoneSystemId)
}
    `;
export type DeletePhoneSystemMutationFn = ApolloReactCommon.MutationFunction<DeletePhoneSystemMutation, DeletePhoneSystemMutationVariables>;

/**
 * __useDeletePhoneSystemMutation__
 *
 * To run a mutation, you first call `useDeletePhoneSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePhoneSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePhoneSystemMutation, { data, loading, error }] = useDeletePhoneSystemMutation({
 *   variables: {
 *      phoneSystemId: // value for 'phoneSystemId'
 *   },
 * });
 */
export function useDeletePhoneSystemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePhoneSystemMutation, DeletePhoneSystemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePhoneSystemMutation, DeletePhoneSystemMutationVariables>(DeletePhoneSystemDocument, baseOptions);
      }
export type DeletePhoneSystemMutationHookResult = ReturnType<typeof useDeletePhoneSystemMutation>;
export type DeletePhoneSystemMutationResult = ApolloReactCommon.MutationResult<DeletePhoneSystemMutation>;
export type DeletePhoneSystemMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePhoneSystemMutation, DeletePhoneSystemMutationVariables>;
export const DeletePhoneSystemExtensionDocument = gql`
    mutation DeletePhoneSystemExtension($extensionId: String!) {
  phoneSystemExtensionDelete(extensionId: $extensionId)
}
    `;
export type DeletePhoneSystemExtensionMutationFn = ApolloReactCommon.MutationFunction<DeletePhoneSystemExtensionMutation, DeletePhoneSystemExtensionMutationVariables>;

/**
 * __useDeletePhoneSystemExtensionMutation__
 *
 * To run a mutation, you first call `useDeletePhoneSystemExtensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePhoneSystemExtensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePhoneSystemExtensionMutation, { data, loading, error }] = useDeletePhoneSystemExtensionMutation({
 *   variables: {
 *      extensionId: // value for 'extensionId'
 *   },
 * });
 */
export function useDeletePhoneSystemExtensionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePhoneSystemExtensionMutation, DeletePhoneSystemExtensionMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePhoneSystemExtensionMutation, DeletePhoneSystemExtensionMutationVariables>(DeletePhoneSystemExtensionDocument, baseOptions);
      }
export type DeletePhoneSystemExtensionMutationHookResult = ReturnType<typeof useDeletePhoneSystemExtensionMutation>;
export type DeletePhoneSystemExtensionMutationResult = ApolloReactCommon.MutationResult<DeletePhoneSystemExtensionMutation>;
export type DeletePhoneSystemExtensionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePhoneSystemExtensionMutation, DeletePhoneSystemExtensionMutationVariables>;
export const DeletePhoneSystemHuntGroupDocument = gql`
    mutation DeletePhoneSystemHuntGroup($huntGroupId: String!) {
  phoneSystemHuntGroupDelete(huntGroupId: $huntGroupId)
}
    `;
export type DeletePhoneSystemHuntGroupMutationFn = ApolloReactCommon.MutationFunction<DeletePhoneSystemHuntGroupMutation, DeletePhoneSystemHuntGroupMutationVariables>;

/**
 * __useDeletePhoneSystemHuntGroupMutation__
 *
 * To run a mutation, you first call `useDeletePhoneSystemHuntGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePhoneSystemHuntGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePhoneSystemHuntGroupMutation, { data, loading, error }] = useDeletePhoneSystemHuntGroupMutation({
 *   variables: {
 *      huntGroupId: // value for 'huntGroupId'
 *   },
 * });
 */
export function useDeletePhoneSystemHuntGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePhoneSystemHuntGroupMutation, DeletePhoneSystemHuntGroupMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePhoneSystemHuntGroupMutation, DeletePhoneSystemHuntGroupMutationVariables>(DeletePhoneSystemHuntGroupDocument, baseOptions);
      }
export type DeletePhoneSystemHuntGroupMutationHookResult = ReturnType<typeof useDeletePhoneSystemHuntGroupMutation>;
export type DeletePhoneSystemHuntGroupMutationResult = ApolloReactCommon.MutationResult<DeletePhoneSystemHuntGroupMutation>;
export type DeletePhoneSystemHuntGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePhoneSystemHuntGroupMutation, DeletePhoneSystemHuntGroupMutationVariables>;
export const DeletePhoneSystemNumberDocument = gql`
    mutation DeletePhoneSystemNumber($phoneSystemNumberId: String!) {
  phoneSystemNumberDelete(phoneSystemNumberId: $phoneSystemNumberId)
}
    `;
export type DeletePhoneSystemNumberMutationFn = ApolloReactCommon.MutationFunction<DeletePhoneSystemNumberMutation, DeletePhoneSystemNumberMutationVariables>;

/**
 * __useDeletePhoneSystemNumberMutation__
 *
 * To run a mutation, you first call `useDeletePhoneSystemNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePhoneSystemNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePhoneSystemNumberMutation, { data, loading, error }] = useDeletePhoneSystemNumberMutation({
 *   variables: {
 *      phoneSystemNumberId: // value for 'phoneSystemNumberId'
 *   },
 * });
 */
export function useDeletePhoneSystemNumberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePhoneSystemNumberMutation, DeletePhoneSystemNumberMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePhoneSystemNumberMutation, DeletePhoneSystemNumberMutationVariables>(DeletePhoneSystemNumberDocument, baseOptions);
      }
export type DeletePhoneSystemNumberMutationHookResult = ReturnType<typeof useDeletePhoneSystemNumberMutation>;
export type DeletePhoneSystemNumberMutationResult = ApolloReactCommon.MutationResult<DeletePhoneSystemNumberMutation>;
export type DeletePhoneSystemNumberMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePhoneSystemNumberMutation, DeletePhoneSystemNumberMutationVariables>;
export const GetPhoneSystemServiceDocument = gql`
    query GetPhoneSystemService($id: String!) {
  phoneSystem(id: $id) {
    id
    name
    usagePlan
    usagePlanId
    billingAccount
    extensions {
      id
      number
      longNumber
      customerReference
      password
      portaDisplayNumber
    }
    huntGroups {
      id
      number
      customerReference
      extensionIds
      portaHuntSequence
    }
    numbers {
      id
      number
      customerReference
      flow {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useGetPhoneSystemServiceQuery__
 *
 * To run a query within a React component, call `useGetPhoneSystemServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhoneSystemServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhoneSystemServiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPhoneSystemServiceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPhoneSystemServiceQuery, GetPhoneSystemServiceQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPhoneSystemServiceQuery, GetPhoneSystemServiceQueryVariables>(GetPhoneSystemServiceDocument, baseOptions);
      }
export function useGetPhoneSystemServiceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPhoneSystemServiceQuery, GetPhoneSystemServiceQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPhoneSystemServiceQuery, GetPhoneSystemServiceQueryVariables>(GetPhoneSystemServiceDocument, baseOptions);
        }
export type GetPhoneSystemServiceQueryHookResult = ReturnType<typeof useGetPhoneSystemServiceQuery>;
export type GetPhoneSystemServiceLazyQueryHookResult = ReturnType<typeof useGetPhoneSystemServiceLazyQuery>;
export type GetPhoneSystemServiceQueryResult = ApolloReactCommon.QueryResult<GetPhoneSystemServiceQuery, GetPhoneSystemServiceQueryVariables>;
export const GetPhoneSystemExtensionsDocument = gql`
    query GetPhoneSystemExtensions($phoneSystemId: String!) {
  phoneSystemExtensions(phoneSystemId: $phoneSystemId) {
    id
    number
    customerReference
    portaDisplayNumber
  }
}
    `;

/**
 * __useGetPhoneSystemExtensionsQuery__
 *
 * To run a query within a React component, call `useGetPhoneSystemExtensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhoneSystemExtensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhoneSystemExtensionsQuery({
 *   variables: {
 *      phoneSystemId: // value for 'phoneSystemId'
 *   },
 * });
 */
export function useGetPhoneSystemExtensionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPhoneSystemExtensionsQuery, GetPhoneSystemExtensionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPhoneSystemExtensionsQuery, GetPhoneSystemExtensionsQueryVariables>(GetPhoneSystemExtensionsDocument, baseOptions);
      }
export function useGetPhoneSystemExtensionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPhoneSystemExtensionsQuery, GetPhoneSystemExtensionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPhoneSystemExtensionsQuery, GetPhoneSystemExtensionsQueryVariables>(GetPhoneSystemExtensionsDocument, baseOptions);
        }
export type GetPhoneSystemExtensionsQueryHookResult = ReturnType<typeof useGetPhoneSystemExtensionsQuery>;
export type GetPhoneSystemExtensionsLazyQueryHookResult = ReturnType<typeof useGetPhoneSystemExtensionsLazyQuery>;
export type GetPhoneSystemExtensionsQueryResult = ApolloReactCommon.QueryResult<GetPhoneSystemExtensionsQuery, GetPhoneSystemExtensionsQueryVariables>;
export const GetPhoneSystemHuntGroupsDocument = gql`
    query GetPhoneSystemHuntGroups($phoneSystemId: String!) {
  phoneSystemHuntGroups(phoneSystemId: $phoneSystemId) {
    id
    customerReference
    extensionIds
    number
  }
}
    `;

/**
 * __useGetPhoneSystemHuntGroupsQuery__
 *
 * To run a query within a React component, call `useGetPhoneSystemHuntGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhoneSystemHuntGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhoneSystemHuntGroupsQuery({
 *   variables: {
 *      phoneSystemId: // value for 'phoneSystemId'
 *   },
 * });
 */
export function useGetPhoneSystemHuntGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPhoneSystemHuntGroupsQuery, GetPhoneSystemHuntGroupsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPhoneSystemHuntGroupsQuery, GetPhoneSystemHuntGroupsQueryVariables>(GetPhoneSystemHuntGroupsDocument, baseOptions);
      }
export function useGetPhoneSystemHuntGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPhoneSystemHuntGroupsQuery, GetPhoneSystemHuntGroupsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPhoneSystemHuntGroupsQuery, GetPhoneSystemHuntGroupsQueryVariables>(GetPhoneSystemHuntGroupsDocument, baseOptions);
        }
export type GetPhoneSystemHuntGroupsQueryHookResult = ReturnType<typeof useGetPhoneSystemHuntGroupsQuery>;
export type GetPhoneSystemHuntGroupsLazyQueryHookResult = ReturnType<typeof useGetPhoneSystemHuntGroupsLazyQuery>;
export type GetPhoneSystemHuntGroupsQueryResult = ApolloReactCommon.QueryResult<GetPhoneSystemHuntGroupsQuery, GetPhoneSystemHuntGroupsQueryVariables>;
export const GetPhoneSystemNumbersDocument = gql`
    query GetPhoneSystemNumbers($phoneSystemId: String!) {
  phoneSystemNumbers(phoneSystemId: $phoneSystemId) {
    id
    customerReference
    number
  }
}
    `;

/**
 * __useGetPhoneSystemNumbersQuery__
 *
 * To run a query within a React component, call `useGetPhoneSystemNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhoneSystemNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhoneSystemNumbersQuery({
 *   variables: {
 *      phoneSystemId: // value for 'phoneSystemId'
 *   },
 * });
 */
export function useGetPhoneSystemNumbersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPhoneSystemNumbersQuery, GetPhoneSystemNumbersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPhoneSystemNumbersQuery, GetPhoneSystemNumbersQueryVariables>(GetPhoneSystemNumbersDocument, baseOptions);
      }
export function useGetPhoneSystemNumbersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPhoneSystemNumbersQuery, GetPhoneSystemNumbersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPhoneSystemNumbersQuery, GetPhoneSystemNumbersQueryVariables>(GetPhoneSystemNumbersDocument, baseOptions);
        }
export type GetPhoneSystemNumbersQueryHookResult = ReturnType<typeof useGetPhoneSystemNumbersQuery>;
export type GetPhoneSystemNumbersLazyQueryHookResult = ReturnType<typeof useGetPhoneSystemNumbersLazyQuery>;
export type GetPhoneSystemNumbersQueryResult = ApolloReactCommon.QueryResult<GetPhoneSystemNumbersQuery, GetPhoneSystemNumbersQueryVariables>;
export const GetPhoneSystemServicesDocument = gql`
    query GetPhoneSystemServices {
  phoneSystems(limit: 1000) {
    id
    name
    usagePlan
    usagePlanId
  }
}
    `;

/**
 * __useGetPhoneSystemServicesQuery__
 *
 * To run a query within a React component, call `useGetPhoneSystemServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhoneSystemServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhoneSystemServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPhoneSystemServicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPhoneSystemServicesQuery, GetPhoneSystemServicesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPhoneSystemServicesQuery, GetPhoneSystemServicesQueryVariables>(GetPhoneSystemServicesDocument, baseOptions);
      }
export function useGetPhoneSystemServicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPhoneSystemServicesQuery, GetPhoneSystemServicesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPhoneSystemServicesQuery, GetPhoneSystemServicesQueryVariables>(GetPhoneSystemServicesDocument, baseOptions);
        }
export type GetPhoneSystemServicesQueryHookResult = ReturnType<typeof useGetPhoneSystemServicesQuery>;
export type GetPhoneSystemServicesLazyQueryHookResult = ReturnType<typeof useGetPhoneSystemServicesLazyQuery>;
export type GetPhoneSystemServicesQueryResult = ApolloReactCommon.QueryResult<GetPhoneSystemServicesQuery, GetPhoneSystemServicesQueryVariables>;
export const GetUsagePlansDocument = gql`
    query GetUsagePlans {
  usagePlans {
    id
    name
    alias
    status
    type
    monthlyCharge
    contractTerm
    margin
    productLine
    isSelfService
    inboundVoiceMinutes
    outboundVoiceMinutes
    recordings
    transcriptions
    standardInboundSms
    standardOutboundSms
    simultaneousCallsLimit
    maxExtensions
    maxHuntGroups
    maxDIDNumbers
    max1300Numbers
    internationalDirectDial
  }
}
    `;

/**
 * __useGetUsagePlansQuery__
 *
 * To run a query within a React component, call `useGetUsagePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsagePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsagePlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsagePlansQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUsagePlansQuery, GetUsagePlansQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUsagePlansQuery, GetUsagePlansQueryVariables>(GetUsagePlansDocument, baseOptions);
      }
export function useGetUsagePlansLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUsagePlansQuery, GetUsagePlansQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUsagePlansQuery, GetUsagePlansQueryVariables>(GetUsagePlansDocument, baseOptions);
        }
export type GetUsagePlansQueryHookResult = ReturnType<typeof useGetUsagePlansQuery>;
export type GetUsagePlansLazyQueryHookResult = ReturnType<typeof useGetUsagePlansLazyQuery>;
export type GetUsagePlansQueryResult = ApolloReactCommon.QueryResult<GetUsagePlansQuery, GetUsagePlansQueryVariables>;
export const SearchPhoneSystemDidNumbersDocument = gql`
    query SearchPhoneSystemDidNumbers($query: String!) {
  searchPhoneSystemDIDNumbers(query: $query, limit: 50) {
    id
    number
    city
    country
  }
}
    `;

/**
 * __useSearchPhoneSystemDidNumbersQuery__
 *
 * To run a query within a React component, call `useSearchPhoneSystemDidNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPhoneSystemDidNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPhoneSystemDidNumbersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchPhoneSystemDidNumbersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchPhoneSystemDidNumbersQuery, SearchPhoneSystemDidNumbersQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchPhoneSystemDidNumbersQuery, SearchPhoneSystemDidNumbersQueryVariables>(SearchPhoneSystemDidNumbersDocument, baseOptions);
      }
export function useSearchPhoneSystemDidNumbersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchPhoneSystemDidNumbersQuery, SearchPhoneSystemDidNumbersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchPhoneSystemDidNumbersQuery, SearchPhoneSystemDidNumbersQueryVariables>(SearchPhoneSystemDidNumbersDocument, baseOptions);
        }
export type SearchPhoneSystemDidNumbersQueryHookResult = ReturnType<typeof useSearchPhoneSystemDidNumbersQuery>;
export type SearchPhoneSystemDidNumbersLazyQueryHookResult = ReturnType<typeof useSearchPhoneSystemDidNumbersLazyQuery>;
export type SearchPhoneSystemDidNumbersQueryResult = ApolloReactCommon.QueryResult<SearchPhoneSystemDidNumbersQuery, SearchPhoneSystemDidNumbersQueryVariables>;
export const UpdatePhoneSystemExtensionDocument = gql`
    mutation UpdatePhoneSystemExtension($extensionId: String!, $name: String!, $number: String!, $displayNumber: String!) {
  phoneSystemExtensionUpdate(extensionId: $extensionId, name: $name, number: $number, displayNumber: $displayNumber) {
    id
    number
    customerReference
    portaDisplayNumber
  }
}
    `;
export type UpdatePhoneSystemExtensionMutationFn = ApolloReactCommon.MutationFunction<UpdatePhoneSystemExtensionMutation, UpdatePhoneSystemExtensionMutationVariables>;

/**
 * __useUpdatePhoneSystemExtensionMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneSystemExtensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneSystemExtensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneSystemExtensionMutation, { data, loading, error }] = useUpdatePhoneSystemExtensionMutation({
 *   variables: {
 *      extensionId: // value for 'extensionId'
 *      name: // value for 'name'
 *      number: // value for 'number'
 *      displayNumber: // value for 'displayNumber'
 *   },
 * });
 */
export function useUpdatePhoneSystemExtensionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePhoneSystemExtensionMutation, UpdatePhoneSystemExtensionMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePhoneSystemExtensionMutation, UpdatePhoneSystemExtensionMutationVariables>(UpdatePhoneSystemExtensionDocument, baseOptions);
      }
export type UpdatePhoneSystemExtensionMutationHookResult = ReturnType<typeof useUpdatePhoneSystemExtensionMutation>;
export type UpdatePhoneSystemExtensionMutationResult = ApolloReactCommon.MutationResult<UpdatePhoneSystemExtensionMutation>;
export type UpdatePhoneSystemExtensionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePhoneSystemExtensionMutation, UpdatePhoneSystemExtensionMutationVariables>;
export const UpdatePhoneSystemHuntGroupDocument = gql`
    mutation UpdatePhoneSystemHuntGroup($huntGroupId: String!, $extensionIds: [String!]!, $name: String!, $number: String!, $huntSequence: String!) {
  phoneSystemHuntGroupUpdate(huntGroupId: $huntGroupId, extensionIds: $extensionIds, name: $name, number: $number, huntSequence: $huntSequence) {
    id
    extensionIds
    customerReference
    number
    portaHuntSequence
  }
}
    `;
export type UpdatePhoneSystemHuntGroupMutationFn = ApolloReactCommon.MutationFunction<UpdatePhoneSystemHuntGroupMutation, UpdatePhoneSystemHuntGroupMutationVariables>;

/**
 * __useUpdatePhoneSystemHuntGroupMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneSystemHuntGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneSystemHuntGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneSystemHuntGroupMutation, { data, loading, error }] = useUpdatePhoneSystemHuntGroupMutation({
 *   variables: {
 *      huntGroupId: // value for 'huntGroupId'
 *      extensionIds: // value for 'extensionIds'
 *      name: // value for 'name'
 *      number: // value for 'number'
 *      huntSequence: // value for 'huntSequence'
 *   },
 * });
 */
export function useUpdatePhoneSystemHuntGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePhoneSystemHuntGroupMutation, UpdatePhoneSystemHuntGroupMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePhoneSystemHuntGroupMutation, UpdatePhoneSystemHuntGroupMutationVariables>(UpdatePhoneSystemHuntGroupDocument, baseOptions);
      }
export type UpdatePhoneSystemHuntGroupMutationHookResult = ReturnType<typeof useUpdatePhoneSystemHuntGroupMutation>;
export type UpdatePhoneSystemHuntGroupMutationResult = ApolloReactCommon.MutationResult<UpdatePhoneSystemHuntGroupMutation>;
export type UpdatePhoneSystemHuntGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePhoneSystemHuntGroupMutation, UpdatePhoneSystemHuntGroupMutationVariables>;
export const UpdatePhoneSystemNumberDocument = gql`
    mutation UpdatePhoneSystemNumber($phoneSystemNumberId: String!, $customerReference: String!, $flowId: String!) {
  phoneSystemNumberUpdate(phoneSystemNumberId: $phoneSystemNumberId, customerReference: $customerReference, flowId: $flowId) {
    id
    customerReference
  }
}
    `;
export type UpdatePhoneSystemNumberMutationFn = ApolloReactCommon.MutationFunction<UpdatePhoneSystemNumberMutation, UpdatePhoneSystemNumberMutationVariables>;

/**
 * __useUpdatePhoneSystemNumberMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneSystemNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneSystemNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneSystemNumberMutation, { data, loading, error }] = useUpdatePhoneSystemNumberMutation({
 *   variables: {
 *      phoneSystemNumberId: // value for 'phoneSystemNumberId'
 *      customerReference: // value for 'customerReference'
 *      flowId: // value for 'flowId'
 *   },
 * });
 */
export function useUpdatePhoneSystemNumberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePhoneSystemNumberMutation, UpdatePhoneSystemNumberMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePhoneSystemNumberMutation, UpdatePhoneSystemNumberMutationVariables>(UpdatePhoneSystemNumberDocument, baseOptions);
      }
export type UpdatePhoneSystemNumberMutationHookResult = ReturnType<typeof useUpdatePhoneSystemNumberMutation>;
export type UpdatePhoneSystemNumberMutationResult = ApolloReactCommon.MutationResult<UpdatePhoneSystemNumberMutation>;
export type UpdatePhoneSystemNumberMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePhoneSystemNumberMutation, UpdatePhoneSystemNumberMutationVariables>;
export const ListRecordingsDocument = gql`
    query ListRecordings($page: Float!, $serviceId: String, $ban: String, $from: String) {
  recordings(page: $page, serviceId: $serviceId, ban: $ban, from: $from) {
    totalPages
    results {
      id
      serviceId
      source
      transcriptions {
        sid
      }
      sid
      dateCreated
    }
  }
}
    `;

/**
 * __useListRecordingsQuery__
 *
 * To run a query within a React component, call `useListRecordingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRecordingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRecordingsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      serviceId: // value for 'serviceId'
 *      ban: // value for 'ban'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useListRecordingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListRecordingsQuery, ListRecordingsQueryVariables>) {
        return ApolloReactHooks.useQuery<ListRecordingsQuery, ListRecordingsQueryVariables>(ListRecordingsDocument, baseOptions);
      }
export function useListRecordingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListRecordingsQuery, ListRecordingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ListRecordingsQuery, ListRecordingsQueryVariables>(ListRecordingsDocument, baseOptions);
        }
export type ListRecordingsQueryHookResult = ReturnType<typeof useListRecordingsQuery>;
export type ListRecordingsLazyQueryHookResult = ReturnType<typeof useListRecordingsLazyQuery>;
export type ListRecordingsQueryResult = ApolloReactCommon.QueryResult<ListRecordingsQuery, ListRecordingsQueryVariables>;
export const ListCallsDocument = gql`
    query ListCalls($serviceId: String, $page: Int!, $filterDate: String) {
  calls(page: $page, limit: 20, serviceId: $serviceId, filterDate: $filterDate) {
    totalPages
    results {
      dateTime
      incomingCaller
      answerPoint
      location
      state
      callStatus
      duration
      target
      usageType
      amountCharged
    }
  }
}
    `;

/**
 * __useListCallsQuery__
 *
 * To run a query within a React component, call `useListCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCallsQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      page: // value for 'page'
 *      filterDate: // value for 'filterDate'
 *   },
 * });
 */
export function useListCallsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListCallsQuery, ListCallsQueryVariables>) {
        return ApolloReactHooks.useQuery<ListCallsQuery, ListCallsQueryVariables>(ListCallsDocument, baseOptions);
      }
export function useListCallsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListCallsQuery, ListCallsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ListCallsQuery, ListCallsQueryVariables>(ListCallsDocument, baseOptions);
        }
export type ListCallsQueryHookResult = ReturnType<typeof useListCallsQuery>;
export type ListCallsLazyQueryHookResult = ReturnType<typeof useListCallsLazyQuery>;
export type ListCallsQueryResult = ApolloReactCommon.QueryResult<ListCallsQuery, ListCallsQueryVariables>;
export const GetRecordingDocument = gql`
    query GetRecording($recordingId: String!) {
  recording(recordingId: $recordingId) {
    id
    serviceId
    source
    transcriptions {
      sid
      transcriptionText
    }
    sid
    dateCreated
    duration
    status
    twilioCall {
      from
      contact {
        id
        firstName
        lastName
        company
      }
    }
  }
}
    `;

/**
 * __useGetRecordingQuery__
 *
 * To run a query within a React component, call `useGetRecordingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordingQuery({
 *   variables: {
 *      recordingId: // value for 'recordingId'
 *   },
 * });
 */
export function useGetRecordingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecordingQuery, GetRecordingQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRecordingQuery, GetRecordingQueryVariables>(GetRecordingDocument, baseOptions);
      }
export function useGetRecordingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecordingQuery, GetRecordingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRecordingQuery, GetRecordingQueryVariables>(GetRecordingDocument, baseOptions);
        }
export type GetRecordingQueryHookResult = ReturnType<typeof useGetRecordingQuery>;
export type GetRecordingLazyQueryHookResult = ReturnType<typeof useGetRecordingLazyQuery>;
export type GetRecordingQueryResult = ApolloReactCommon.QueryResult<GetRecordingQuery, GetRecordingQueryVariables>;


// WEBPACK FOOTER //
// src/generated/graphql.tsx